var _polygon, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.38,97.32l-2.43-4c-20.52-33.8-57.61-54.18-96.72-51.71a102.44,102.44,0,0,0-15,2.06c-35.56,7.61-66.49,34.5-79.32,68.93-7.54,20.26-9.65,43.57-24,59.65-18.63,20.92-50.25,21.58-78.06,20.71s-59.44-.13-78,20.88C49.33,227,45.64,245.68,46.58,263.3c2.47,46.64,35,88.34,76.31,109.07s90,22.59,135.23,13.47C321.49,373.06,381.75,338,418,283.8S463.37,155.8,434.38,97.32Z",
    style: {
      fill: "#F0F5FA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.26,470.51c0,.14-93.25.26-208.25.26s-208.27-.12-208.27-.26,93.23-.26,208.27-.26S457.26,470.36,457.26,470.51Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character-2",
    "data-motion": "breathe",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "236.57 145.07 244.33 143.39 272.07 145.67 277.97 148.21 252.67 177.84 236.57 145.07",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.68,142.68q-2.3-25.43-4.61-50.86l-20,3.4-2.67,18.83c-.46,3.28-.93,6.63-.32,9.89.56,3,2,5.73,2.51,8.71a14.82,14.82,0,0,1-3.5,12.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,101a31.54,31.54,0,0,0-11.63-21.5c-5.92-4.56-12.62-5.79-20.07-5.42-3.67.19-7.81,1.92-11,3.75C234.84,80.32,233,85.37,231,90c-4.16,9.2-3.53,21.6-.63,25l52.34,30.84c6.75-3.58,5.86-15.58,3.55-22.86A127.21,127.21,0,0,1,281.9,101Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.31,86.43l-24.15-6.91c-7.77-1.07-13.26,8.37-14,16.18-.82,8.67-1.48,19.3-.65,25.82,1.66,13.1,11.61,15.08,11.61,15.08s0,.19,0,4.07l-.19,5.64c3,10.66,23.61,8.9,25.81,1.37l5.54-56.47A4.59,4.59,0,0,0,269.31,86.43Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.05,107.51a1.67,1.67,0,0,0,1.56,1.74,1.6,1.6,0,0,0,1.77-1.45,1.68,1.68,0,0,0-1.56-1.74A1.59,1.59,0,0,0,234.05,107.51Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.45,103.26c.2.22,1.5-.67,3.3-.61s3.09,1,3.29.79-.1-.5-.66-.94a4.6,4.6,0,0,0-2.63-.9,4.45,4.45,0,0,0-2.63.76C233.56,102.77,233.36,103.16,233.45,103.26Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,107.29a1.68,1.68,0,0,0,1.56,1.74,1.6,1.6,0,0,0,1.77-1.45,1.66,1.66,0,0,0-1.56-1.74A1.6,1.6,0,0,0,250.33,107.29Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,103.33c.2.22,1.5-.68,3.3-.62s3.09,1,3.29.79-.1-.49-.66-.93a4.58,4.58,0,0,0-2.63-.9,4.35,4.35,0,0,0-2.63.76C251.14,102.84,250.94,103.22,251,103.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,115.94a11.85,11.85,0,0,0-2.91-.61c-.45-.07-.89-.17-.95-.49a2.33,2.33,0,0,1,.35-1.35l1.46-3.46c2.05-4.92,3.54-9,3.34-9.06s-2,3.85-4.06,8.77c-.49,1.22-1,2.37-1.41,3.48a2.63,2.63,0,0,0-.29,1.8,1.11,1.11,0,0,0,.73.69,3.07,3.07,0,0,0,.78.14A11.31,11.31,0,0,0,244.22,115.94Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.13,136.6a30.17,30.17,0,0,0,17.8-3.51s-4.8,8.86-17.82,7.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,119.51a2.4,2.4,0,0,0-2-1.15,3.12,3.12,0,0,0-2.89,1.32,1.92,1.92,0,0,0-.17,1.39c.1.24,0,.12.2.29a5.59,5.59,0,0,0,2.19,1.46A2.35,2.35,0,0,0,250,122,2.39,2.39,0,0,0,250.13,119.51Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,117.43c-.29,0-.37,1.93-2.09,3.25s-3.79,1-3.82,1.31c0,.12.45.39,1.33.45a4.86,4.86,0,0,0,3.18-1,4.17,4.17,0,0,0,1.63-2.73C250.14,117.92,249.94,117.42,249.8,117.43Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4,97.64c.13.5,1.95.43,4,.87s3.73,1.17,4.05.76c.14-.2-.11-.69-.76-1.22a6.83,6.83,0,0,0-2.93-1.33,6.9,6.9,0,0,0-3.22.09C250.77,97.05,250.34,97.4,250.4,97.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,99.31c.41.35,1.72-.28,3.36-.55s3.09-.2,3.34-.67c.11-.23-.17-.6-.84-.89a5.44,5.44,0,0,0-5.4,1C233.49,98.69,233.36,99.13,233.54,99.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.13,78.61a28.85,28.85,0,0,0,2.17,15.54,10.63,10.63,0,0,0,2.41,3.69,4.79,4.79,0,0,0,4.08,1.29A17.67,17.67,0,0,1,250.16,89c1.57,3.7,3.18,7.46,5.82,10.49s6.53,5.25,10.53,4.88l-.28-2.69a9.31,9.31,0,0,0,3.19,5,4.75,4.75,0,0,0,5.6.11c-1.37-6.53,2.6-13.63.07-19.8-1.75-4.27-6.2-6.82-10.61-8.2a36.88,36.88,0,0,0-19.25-.7",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,78.72l-.06.28,0,0C245.66,78.92,245.67,78.82,245.67,78.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.61,79l-.79-.32c-2.47-1.27-4.08-2.7-7.9.69a23.71,23.71,0,0,0-5.23,7.41,30.61,30.61,0,0,0-2.87,8,34.8,34.8,0,0,0-.24,10c2.21-1.47,3.33-4.1,4-6.66s1.11-5.24,2.39-7.56a19.9,19.9,0,0,0-.37,6.61,2.71,2.71,0,0,0,.72,1.63,1.16,1.16,0,0,0,1.62,0,14.25,14.25,0,0,1,0-7.85,40.37,40.37,0,0,1,2.93-7.38,39.19,39.19,0,0,0,.54,13.27,3.43,3.43,0,0,0,.75,1.73,3.13,3.13,0,0,0,2.71.55,6.63,6.63,0,0,1,2.83-.13A37.52,37.52,0,0,1,245.61,79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,137.59c.31-3-2.73-6.5-2.4-9.54.35-3.22,2.41-6,3.24-9.13,2-7.59-3.45-15.86-.89-23.3L276,97l6.66,48.88-23.3.9C261.42,143.76,265.63,141.18,266,137.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.81,189.54,179.5,202.23l-26.95-6.65L142,205.24s28,16.27,33.19,17.82c5.88,1.76,9.79.21,14.9-3.44s16.09-17.19,16.09-17.19Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.25,196.76,150.6,194s-.63-5.37-1.66-7.59S141,176.24,141,176.24a2.64,2.64,0,0,0-1.42,3c.26.93,3.54,7.23,3.54,7.23h0c-.75.55-2.38.92-4.3-.39-2.37-1.6-5.15-3.43-5.55-3.6s-1.92-3.72-3-6.36c-.63-1.59-3.15-1.43-3.39.26a.94.94,0,0,0,0,.48s-2.68-1.29-1.92,3.37c0,0-2.1,3.07-.81,5.46,0,0-1,4.38-.36,6.32s12,10,12,10l12.67,7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,195.61a17,17,0,0,1-1.29-1.82,7.4,7.4,0,0,1-.79-2.25,7.14,7.14,0,0,1,.08-2.9,7.43,7.43,0,0,1,.81-2l.06-.09-.07-.11c-.73-1.32-1.33-2.59-1.79-3.42a5.65,5.65,0,0,0-.8-1.31s0,.14.14.38l.47,1c.41.88.92,2.09,1.7,3.54v-.2a7.36,7.36,0,0,0-.93,5.19,7.23,7.23,0,0,0,.91,2.31,6.53,6.53,0,0,0,1,1.31A2.11,2.11,0,0,0,144.46,195.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,193.55a11.45,11.45,0,0,0-1.34-1.07,6.19,6.19,0,0,1-2.37-3.14c-.19-.75-.19-1.53-.39-2.24a2.41,2.41,0,0,0-1.1-1.57,1.49,1.49,0,0,0-1.29-.08c-.29.14-.37.31-.36.32s.14-.11.41-.19a1.45,1.45,0,0,1,1.12.17,2.28,2.28,0,0,1,.89,1.44c.17.65.16,1.43.36,2.24a4.89,4.89,0,0,0,1.14,2,8.74,8.74,0,0,0,1.44,1.22A6.74,6.74,0,0,0,131,193.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.73,190.18a17.74,17.74,0,0,0-1.92-1.23,10.78,10.78,0,0,1-3.83-3.74,6,6,0,0,1-.55-1.41,9.9,9.9,0,0,1-.2-1.42,3.1,3.1,0,0,0-1-2.3,1.37,1.37,0,0,0-1-.28,1.32,1.32,0,0,0-.7.28c-.33.29-.31.57-.3.56s.07-.23.38-.44a1.22,1.22,0,0,1,1.43.08,2.92,2.92,0,0,1,.83,2.13,10,10,0,0,0,.19,1.47,6,6,0,0,0,.58,1.51,10.14,10.14,0,0,0,4,3.78c.62.35,1.13.61,1.49.78A1.9,1.9,0,0,0,134.73,190.18Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64,176.56A4.48,4.48,0,0,1,128,178a9.7,9.7,0,0,1,.82,2,11.67,11.67,0,0,0,1.06,2.57,9.9,9.9,0,0,0,3.56,3.53,8.56,8.56,0,0,0,1.39.64,1.71,1.71,0,0,0,.55.13c0-.06-.74-.31-1.8-1a10.53,10.53,0,0,1-3.38-3.5,12.44,12.44,0,0,1-1-2.48,9,9,0,0,0-.93-2.08A2.61,2.61,0,0,0,126.64,176.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,440l1,19s-19,6-19.14,9.56l36.93.75L249,439.64Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243,457.22a1.5,1.5,0,0,1,1.07,1.7,1.44,1.44,0,0,1-1.68,1.08,1.58,1.58,0,0,1-1.12-1.81,1.5,1.5,0,0,1,1.87-.93",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.35,469.32l0-3-35.68.51a2.57,2.57,0,0,0-1.4,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231,458.84c0,.18.91.24,1.81.81s1.38,1.31,1.55,1.24-.13-1.11-1.22-1.78S230.92,458.67,231,458.84Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.11,460.5c0,.18.75.47,1.38,1.22s.81,1.56,1,1.55.28-1-.52-1.95S227.12,460.33,227.11,460.5Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,465.18c.17,0,.4-.87-.08-1.85s-1.33-1.36-1.4-1.21.46.67.84,1.48S224.81,465.16,225,465.18Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,454.48c.08.16.9-.1,1.92-.05s1.82.36,1.91.2-.68-.78-1.88-.83S231.12,454.34,231.21,454.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,450.64a3.45,3.45,0,0,0,1.85,0,8.07,8.07,0,0,0,1.92-.63,7.84,7.84,0,0,0,1.05-.58,2.28,2.28,0,0,0,.56-.44.79.79,0,0,0,.06-1,1,1,0,0,0-.8-.4,2,2,0,0,0-.69.11,5.69,5.69,0,0,0-1.14.41,6.48,6.48,0,0,0-1.69,1.15c-.84.81-1.12,1.48-1.06,1.52s.49-.52,1.35-1.19a7.16,7.16,0,0,1,1.64-.95,6.47,6.47,0,0,1,1.05-.35c.39-.11.72-.12.83.06s0,.09,0,.2a1.63,1.63,0,0,1-.41.33,8.06,8.06,0,0,1-1,.57,10.54,10.54,0,0,1-1.78.72A11.76,11.76,0,0,0,231.08,450.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.32,450.9a3,3,0,0,0,.45-1.8,5.9,5.9,0,0,0-.28-2A6,6,0,0,0,231,446a1.54,1.54,0,0,0-1.2-.92.89.89,0,0,0-.76.53,2.46,2.46,0,0,0-.18.68,4.33,4.33,0,0,0,0,1.25,4.22,4.22,0,0,0,.82,1.89c.74,1,1.5,1.15,1.51,1.09s-.57-.43-1.14-1.34a4.36,4.36,0,0,1-.62-1.73,3.78,3.78,0,0,1,0-1.06c.05-.4.19-.72.34-.68s.5.28.66.59a6.43,6.43,0,0,1,.47,1,6.54,6.54,0,0,1,.39,1.84C231.4,450.19,231.22,450.87,231.32,450.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15,437.94l.71,24.54L276,481.73a2.51,2.51,0,0,1-1.79,3.21h0a2.49,2.49,0,0,1-2.24-.53c-3.93-3.4-18.31-16-18.26-17.76.05-2.08-2.47-25.83-2.47-25.83Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.22,484.94,253.63,465l.05,1a3.79,3.79,0,0,0,1,2.4c1.65,1.75,6.31,6.48,17.19,16a2.54,2.54,0,0,0,2.32.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.25,456.83a1.51,1.51,0,0,1,.52,2,1.46,1.46,0,0,1-1.94.53,1.6,1.6,0,0,1-.54-2.08,1.52,1.52,0,0,1,2.08-.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.06,474.52c.14.06.63-1.25,2.05-2a7.85,7.85,0,0,1,2.8-.69c0-.06-.31-.23-.88-.28a3.89,3.89,0,0,0-2.18.5,3.82,3.82,0,0,0-1.57,1.59C268,474.14,268,474.5,268.06,474.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,477.71c.12.1.86-.74,2.11-1.17a23.65,23.65,0,0,1,2.38-.43,2.76,2.76,0,0,0-2.56-.07C270.49,476.53,269.85,477.65,270,477.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,470.48a23.92,23.92,0,0,1,3.15-2,25.78,25.78,0,0,1,3.59-1,6.89,6.89,0,0,0-6.74,3.06Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.75,463c.08.14,1.4-.5,3.16-.65s3.18.2,3.22,0a6.22,6.22,0,0,0-6.38.61Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,455.84a12.55,12.55,0,0,1,3.27-.76,12,12,0,0,1,3.3.65c0-.06-.25-.35-.83-.65a5.33,5.33,0,0,0-2.48-.54,5.52,5.52,0,0,0-2.45.62C263.6,455.48,263.32,455.79,263.36,455.84Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.52,453.71a2.09,2.09,0,0,0,0-.93,6.33,6.33,0,0,0-.86-2.39,2.88,2.88,0,0,0-1.29-1.3,1,1,0,0,0-1.13.28,1.67,1.67,0,0,0-.33,1.13,3.56,3.56,0,0,0,3.28,3.12,4.09,4.09,0,0,0,3.93-2.36,1.41,1.41,0,0,0,0-1.19,1,1,0,0,0-1.06-.47,3.43,3.43,0,0,0-1.57.92,7.16,7.16,0,0,0-1.58,2,2.14,2.14,0,0,0-.33.87,11.56,11.56,0,0,1,2.15-2.57,3.35,3.35,0,0,1,1.39-.77.52.52,0,0,1,.58.25,1,1,0,0,1-.05.79,3.68,3.68,0,0,1-3.43,2,3.08,3.08,0,0,1-2.82-2.62,1.17,1.17,0,0,1,.19-.79.54.54,0,0,1,.62-.17,2.59,2.59,0,0,1,1.12,1.08A9.53,9.53,0,0,1,266.52,453.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.61 281.89 247.43 452.42 273.63 454.54 295.48 277.97 242.61 281.89",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.27,279.72s3.55,54.12,6.93,74.41,11.63,93.58,15.5,95.27,26.34-.6,26.34-.6l8-167.36Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "208.01 290.33 208.23 293.38 249.95 298.65 261.99 291.79 286.16 290.55 208.01 290.33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,450.73c-.14,0,.51-34.91,1.45-78s1.83-78,2-78-.51,34.91-1.46,78S246.67,450.73,246.53,450.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32,196.12s28.2-40.46,30.55-41,27.93-11.74,27.93-11.74l15.4,31.06,23.5-26.89s21.93,16.45,23.23,20.11-16.71,56.12-16.71,56.12,8.1,12.53,9.66,26.63-1.56,40.73-1.56,40.73l-89-.82s-.94-39.33,5.82-59.83c3.65-11.05,7.7-24.2,7.7-24.2l-2.09-7.57-14.62,16.45Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.38,187.2l.47-.17a6.55,6.55,0,0,1,1.44-.32,14.31,14.31,0,0,1,5.54.6c2.32.62,5.06,1.62,8.21,2.69,1.58.54,3.26,1.07,5.06,1.54a24.68,24.68,0,0,0,5.72.92h.28l-.05.26c-1.34,7.47-2.92,16.21-4.6,25.52-.09.48-.17.95-.26,1.42l-.05.32-.3-.14c-2.14-1-4.27-1.88-6.37-2.73a49,49,0,0,0-6.23-2.15,87.67,87.67,0,0,0-12-1.56l-.23,0,0-.23c1-7.79,1.78-14.28,2.35-18.87.29-2.24.52-4,.69-5.25.08-.58.14-1,.19-1.37a2.32,2.32,0,0,1,.08-.46,3.07,3.07,0,0,1,0,.5c0,.35-.08.82-.14,1.41-.13,1.26-.32,3-.57,5.29-.52,4.58-1.25,11-2.14,18.8l-.2-.24a86.36,86.36,0,0,1,12.05,1.53,47.94,47.94,0,0,1,6.31,2.15q3.16,1.28,6.39,2.74l-.36.19c.09-.47.17-.94.26-1.42,1.7-9.31,3.3-18,4.66-25.51l.24.27a24.75,24.75,0,0,1-5.85-1c-1.81-.49-3.5-1-5.08-1.59-3.15-1.11-5.87-2.13-8.16-2.79a14.78,14.78,0,0,0-5.45-.71A17.67,17.67,0,0,0,260.38,187.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.93 167.66 314.51 218.83 287.01 228.79 284.22 223.79 300.93 167.66",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.35,280.45l.22,0,.66.11,2.52.42c2.19.35,5.37.84,9.33,1.12a42,42,0,0,0,6.45,0,13,13,0,0,0,1.74-.25c.29-.06.59-.1.88-.18l.86-.29c1.15-.32,1.79-1.53,2.31-2.67a21.09,21.09,0,0,0,1.16-3.81c.3-1.33.54-2.71.74-4.12.4-2.82.66-5.76.84-8.78.4-6.6.45-12.88.36-18.43l.22.22-18.36-.38-5.21-.15-1.39-.06a2.15,2.15,0,0,1-.47,0,2.91,2.91,0,0,1,.48,0l1.38,0,5.22,0,18.36.2h.22v.22c.13,5.58.09,11.86-.31,18.48-.18,3-.44,6-.86,8.82-.2,1.42-.44,2.81-.75,4.16a21.72,21.72,0,0,1-1.21,3.89,8.24,8.24,0,0,1-1,1.73,4.77,4.77,0,0,1-.7.72,3,3,0,0,1-.89.45l-.91.3c-.3.08-.6.12-.9.18a14,14,0,0,1-1.79.24,42.49,42.49,0,0,1-6.52-.06,89.91,89.91,0,0,1-9.33-1.28c-1.09-.21-1.94-.39-2.51-.52l-.65-.16Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,250c0,.14-5.86.26-13.08.26s-13.08-.12-13.08-.26,5.86-.26,13.08-.26S231.39,249.87,231.39,250Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22,192.9c.11.09-6.61,9.15-15,20.25s-15.31,20-15.42,19.93,6.61-9.15,15-20.24S243.11,192.82,243.22,192.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.78,198.73a10.33,10.33,0,0,1-.28-1.56c-.16-1-.35-2.47-.55-4.28-.39-3.62-.79-8.65-.83-14.22a119.59,119.59,0,0,1,.74-14.23c.21-1.82.4-3.28.58-4.28a10.28,10.28,0,0,1,.3-1.56,8.08,8.08,0,0,1-.11,1.58c-.11,1-.25,2.48-.41,4.29-.32,3.63-.63,8.64-.59,14.19s.38,10.57.68,14.19c.16,1.75.29,3.2.38,4.3A8.89,8.89,0,0,1,214.78,198.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,182.32a8.76,8.76,0,0,1-.47,1.37c-.33.88-.83,2.14-1.48,3.68-1.28,3.09-3.15,7.32-5.36,11.92s-4.37,8.69-6,11.61c-.81,1.47-1.48,2.64-2,3.44a7.83,7.83,0,0,1-.79,1.23,8,8,0,0,1,.61-1.32l1.82-3.52c1.53-3,3.63-7.08,5.85-11.67s4.12-8.79,5.49-11.83c.66-1.46,1.2-2.67,1.63-3.61A6.4,6.4,0,0,1,234.66,182.32Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22,152.58a4.13,4.13,0,0,1-.45.67l-1.38,1.88-5.18,6.9-17.59,23.14-.07.1h-11.3l-.07-.14c-5-10.68-9.53-20.16-12.77-27-1.58-3.4-2.85-6.14-3.76-8.08-.41-.92-.75-1.65-1-2.19l-.25-.57c0-.13-.07-.2-.06-.2l.11.18.29.55,1.07,2.15c.94,1.92,2.26,4.64,3.9,8,3.28,6.84,7.82,16.3,12.92,26.95l-.23-.15h11l-.2.1,17.72-23c2.23-2.87,4-5.18,5.31-6.81l1.44-1.82A5.85,5.85,0,0,1,284.22,152.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.24,246.08a5,5,0,0,1-.72-.82c-.43-.55-1-1.37-1.71-2.41a53.88,53.88,0,0,1-7.59-17.91c-.26-1.22-.44-2.21-.53-2.91a4.56,4.56,0,0,1-.1-1.08c.08,0,.37,1.5,1,3.91a64.46,64.46,0,0,0,7.54,17.79C281.41,244.77,282.3,246,282.24,246.08Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.39,231.43c-.09-.12,2.28-1.77,5-4.07s4.69-4.38,4.8-4.28a23.11,23.11,0,0,1-4.47,4.67A23.44,23.44,0,0,1,275.39,231.43Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,230.74s-.09-.11-.23-.34l-.58-1L285,225.43l0-.05,0-.06c1.43-5.51,3.85-14.55,6.62-24.74l6-21.59c.77-2.71,1.4-4.93,1.86-6.53l.53-1.77a2.72,2.72,0,0,1,.22-.6,2.52,2.52,0,0,1-.12.63c-.11.46-.26,1.06-.44,1.79-.42,1.62-1,3.85-1.7,6.57l-5.81,21.64c-2.78,10.19-5.28,19.2-6.83,24.68v-.11c.83,1.67,1.51,3,2,4,.21.43.38.79.51,1.07A1.44,1.44,0,0,1,288,230.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.21,193.78a210.16,210.16,0,0,0-22.84,36.94l.67-.34,6.48-9,15.88-22.07a6.7,6.7,0,0,0,1.45-3A2.27,2.27,0,0,0,237.21,193.78Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.78,198.73a34.59,34.59,0,0,1-1.13-29.64S213.78,193.91,214.78,198.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,198.19a3.87,3.87,0,0,1-1-.09c-.67-.09-1.63-.24-2.82-.45-2.37-.43-5.63-1.09-9.2-2s-6.76-1.81-9.06-2.54c-1.15-.37-2.07-.68-2.7-.91a4.14,4.14,0,0,1-1-.41,4.64,4.64,0,0,1,1,.22l2.74.75c2.32.64,5.52,1.51,9.08,2.39s6.8,1.6,9.15,2.11l2.78.62A4.44,4.44,0,0,1,285.52,198.19Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.28,213.18s17.39,8.46,24.66,6.43C281.94,219.61,269.54,212.67,257.28,213.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286,223.08s13.4-8.39,10.84-41.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.86,290.33c0,.14-18.95.26-42.33.26s-42.34-.12-42.34-.26,18.95-.25,42.34-.25S288.86,290.19,288.86,290.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.78,222s1.92,31.9,1.14,36.86-3.59,27.42-3.59,27.42L292,284,289,228.12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,285.53c-.12-.28-.18-.44-.18-.44L292,282.74s-4.08,11.24-4.47,13,.26,7-.51,9.65,1,2.84,2.11,2.84S294.33,296,294.33,296l.77,5.66-2.58,5.66s.52,3.48,1.29,3.37,3.77-2.46,3.77-2.46l.48,1.8s-1.42.77.64.64,3.48-2.32,3.48-2.32l1.09,1.68,4.44-4.89s.65-7.47.65-7.95S304.38,287.64,303.45,285.53Z",
    style: {
      fill: "#ffbe9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character-3",
    "data-motion": "breathe",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.37,437.35l1.45,24.08-4.35,19.37a2.48,2.48,0,0,0,2,3h0a2.44,2.44,0,0,0,2.14-.72c3.55-3.66,16.3-17.09,16.25-18.6-.07-1.94.24-25.86.24-25.86Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.51,483.79l18.4-22.08,0,1.79a2.93,2.93,0,0,1-.49,2.2,205,205,0,0,1-15.53,17.74c-.57.6-1.61.49-2.42.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.68,454.89a1.49,1.49,0,0,0-.34,2,1.44,1.44,0,0,0,2,.35,1.57,1.57,0,0,0,.35-2.08,1.49,1.49,0,0,0-2.07-.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,473.05a5.29,5.29,0,0,0-5-2.22c0-.06.27-.26.83-.36a3.92,3.92,0,0,1,3.85,1.72C346.63,472.67,346.68,473,346.62,473.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,476.34a21.59,21.59,0,0,0-2.18-.95,20.74,20.74,0,0,0-2.36-.22,2.72,2.72,0,0,1,2.5-.3C344.42,475.24,345.15,476.27,345,476.34Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.67,468.8a23.94,23.94,0,0,0-3.26-1.71,25.19,25.19,0,0,0-3.61-.7,6.75,6.75,0,0,1,6.87,2.41Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.84,461.44c-.06.15-1.41-.36-3.15-.36s-3.09.47-3.15.32a4.82,4.82,0,0,1,3.15-.85A4.74,4.74,0,0,1,349.84,461.44Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.59,454.36a7.86,7.86,0,0,0-6.43.46c0-.05.21-.36.76-.7a5.21,5.21,0,0,1,2.37-.75,5.35,5.35,0,0,1,2.46.4C349.33,454,349.63,454.31,349.59,454.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,452.55a2.07,2.07,0,0,1-.07-.91,6.26,6.26,0,0,1,.64-2.41,2.77,2.77,0,0,1,1.15-1.39,1,1,0,0,1,1.13.18,1.57,1.57,0,0,1,.42,1.07,3.49,3.49,0,0,1-2.94,3.35,4.06,4.06,0,0,1-4-2,1.39,1.39,0,0,1-.11-1.17,1,1,0,0,1,1-.55,3.5,3.5,0,0,1,1.62.76,7.08,7.08,0,0,1,1.71,1.82,2,2,0,0,1,.4.82,10.77,10.77,0,0,0-2.33-2.33,3.18,3.18,0,0,0-1.43-.63.5.5,0,0,0-.54.3.94.94,0,0,0,.11.76,3.64,3.64,0,0,0,3.54,1.67,3,3,0,0,0,2.53-2.81,1.11,1.11,0,0,0-.26-.76.53.53,0,0,0-.62-.11,2.58,2.58,0,0,0-1,1.16A9.38,9.38,0,0,0,346.32,452.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,438.67l-.83,19.92s20,7.53,20.18,11.23l-38.68-.22V438.51Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.82,456.85a1.57,1.57,0,0,0-1.1,1.79,1.52,1.52,0,0,0,1.77,1.11,1.67,1.67,0,0,0,1.16-1.91,1.59,1.59,0,0,0-2-.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.27,469.6v-2.83l37.29,1.08s1.31.89,1.39,2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,458.4c0,.18-.95.26-1.88.87s-1.44,1.39-1.61,1.31.11-1.16,1.26-1.87S381.44,458.22,381.4,458.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.45,460.1c0,.18-.78.5-1.42,1.29s-.84,1.64-1,1.63-.3-1.08.52-2S385.45,459.92,385.45,460.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,465c-.18,0-.43-.9.06-1.93s1.37-1.44,1.45-1.28-.47.7-.86,1.56S387.91,465,387.73,465Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.09,453.83c-.08.18-.95-.09-2,0s-1.9.4-2,.23.71-.83,2-.89S381.18,453.69,381.09,453.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.88,345.67s-10,90.92-13.35,105.43h-39.8s-11.49-79.67-13.35-101.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,357.05c-.14,0-.25,21.05-.25,47s.11,47,.25,47,.26-21.05.26-47S361.13,357.05,361,357.05Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,257.9c-1.82-10.14-9.78-89.78-9.78-89.78l-19.56-7-8.41-9.77-24.34,3.41-8,8s-15.35,4.81-19.22,7.54c0,0-8.37,5.67-11.11,14.61-2.1,6.85-12.15,40.67-12.15,40.67s-2.74,8.25-1.84,13.83c.52,3.18,2.7,9.5,7.94,12.28a19.51,19.51,0,0,0,14.12,1.41l-5.26,90.22s.45,9.09,24.56,13,81.32-7.75,81.32-7.75S410.2,268,408.38,257.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,257.9s.39,2.14.87,6.25,1.11,10.19,1.85,18c1.49,15.66,3.48,38.32,5.79,66.32v.17l-.16,0q-11.43,2.28-24.17,4.25c-8.48,1.3-17.37,2.5-26.65,3.36s-19,1.51-28.93.38a67.43,67.43,0,0,1-14.78-3.51,29.65,29.65,0,0,1-6.92-3.56,15.76,15.76,0,0,1-2.92-2.68,7.61,7.61,0,0,1-1.8-3.62h0v0c1.57-26.93,3.27-56.23,5-86.62.07-1.21.14-2.41.21-3.59l.34.26a20.31,20.31,0,0,1-8.49.49,17.59,17.59,0,0,1-4.09-1.12,14.17,14.17,0,0,1-3.69-2.09A17.1,17.1,0,0,1,295,243.8a20.91,20.91,0,0,1-1.2-4,18.16,18.16,0,0,1-.22-4.16,41.36,41.36,0,0,1,1.39-8.09q1.17-3.9,2.31-7.77,2.31-7.71,4.56-15.26t4.47-14.93a69.75,69.75,0,0,1,2.39-7.29,26.87,26.87,0,0,1,4.06-6.41,34.79,34.79,0,0,1,5.37-5.21,16.76,16.76,0,0,1,3.2-1.92c1.1-.53,2.23-1,3.36-1.46,4.52-1.82,9-3.35,13.54-4.79l-.1.06,8-7.95.06-.06h.07l24.34-3.4h.11l.08.09L379.2,161l-.09-.06,19.55,7,.11,0,0,.12c2.76,27.76,5.08,50.22,6.76,65.73.83,7.76,1.52,13.78,2,17.85.26,2,.44,3.6.6,4.64s.22,1.58.22,1.58-.4-2.13-.93-6.2-1.25-10.09-2.11-17.85c-1.74-15.51-4.12-38-6.93-65.71l.12.16-19.56-7-.05,0,0,0-8.42-9.77.19.07L346.33,155l.13-.06-8,8,0,0,0,0c-4.47,1.44-9,3-13.5,4.78-1.12.46-2.24.93-3.33,1.46a15.11,15.11,0,0,0-3.11,1.87,34.25,34.25,0,0,0-5.3,5.13,26.63,26.63,0,0,0-4,6.3,68.9,68.9,0,0,0-2.37,7.24q-2.19,7.37-4.45,14.93t-4.56,15.27q-1.14,3.85-2.3,7.74a40.72,40.72,0,0,0-1.37,8,17.5,17.5,0,0,0,.21,4,19.88,19.88,0,0,0,1.17,3.9,16.51,16.51,0,0,0,4.7,6.6c4.36,3.31,10.46,4.1,15.78,2.63l.36-.1,0,.37c-.07,1.18-.14,2.38-.21,3.59-1.78,30.39-3.49,59.68-5.06,86.62v0a7.19,7.19,0,0,0,1.68,3.32,15.86,15.86,0,0,0,2.82,2.61,29.92,29.92,0,0,0,6.82,3.5,67.24,67.24,0,0,0,14.66,3.49c9.88,1.13,19.58.43,28.83-.35s18.15-2,26.63-3.33,16.54-2.71,24.15-4.21l-.15.2c-2.26-28-4.19-50.67-5.62-66.33-.7-7.83-1.31-13.91-1.75-18-.24-2.06-.39-3.63-.56-4.68S408.38,257.9,408.38,257.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.19,183.2,395,205.94l2.56,23.65-20.3,2.28,1.41,26.92s26.12-.28,38.63-5.29,9.51-17.45,8.63-23c-1.48-9.23-15.75-54.12-18.65-57.3-3.49-3.84-9.47-5.37-9.47-5.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,151.37a9.7,9.7,0,0,1,2.27,7.5c-.45,4.78-3.86,13.82-5.91,16.55s-14.55,26-14.55,26l-6.37-33.28-.4-10.89,2.44-2.45Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62,200.77a3.82,3.82,0,0,0,.56-.36l1.52-1.11c1.37-1,3.26-2.42,5.57-4.15l8.21-6.2,4.84-3.69a4.31,4.31,0,0,0,1.89-2.72,7.28,7.28,0,0,0-.65-3.34,41.85,41.85,0,0,0-3.35-6.27l-.3.36,8.68,3.85.35.16,0-.38c-.54-4.68-1-8.59-1.32-11.4-.17-1.32-.3-2.39-.4-3.18a7,7,0,0,0-.19-1.12,8.69,8.69,0,0,0,.05,1.13c.07.8.17,1.87.29,3.2.28,2.81.67,6.73,1.13,11.42l.31-.22-8.68-3.92-.72-.33.42.69a42.28,42.28,0,0,1,3.29,6.19,6.91,6.91,0,0,1,.63,3.09,3.89,3.89,0,0,1-1.7,2.4l-4.81,3.7-8.15,6.3-5.47,4.28-1.47,1.18A2.72,2.72,0,0,0,353.62,200.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62,201.4a3.39,3.39,0,0,0-.32-.52l-1-1.42-3.63-5.21c-1.53-2.2-3.35-4.81-5.33-7.75-1-1.47-2-3-3.05-4.64-.52-.81-1-1.64-1.51-2.5a5.57,5.57,0,0,1-1-2.67,4.73,4.73,0,0,1,1.87-3.21,14.4,14.4,0,0,1,3.16-2.06l1.2-.59-1.33.13-9.4.88.17.34,5.76-6.83,1.57-1.91a7.26,7.26,0,0,0,.52-.7,4,4,0,0,0-.62.62l-1.65,1.83-5.89,6.72-.34.38.51,0,9.42-.81-.12-.46a14.3,14.3,0,0,0-3.29,2.12,7.48,7.48,0,0,0-1.37,1.54,3.91,3.91,0,0,0-.68,2,2.76,2.76,0,0,0,.09.81l.1.4.16.36a14.55,14.55,0,0,0,.71,1.36c.49.87,1,1.71,1.53,2.52,1,1.63,2.08,3.17,3.08,4.63,2,2.93,3.86,5.53,5.43,7.7s2.86,3.91,3.76,5.11l1.05,1.37A2.62,2.62,0,0,0,350.62,201.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.54,357.1c.14,0,.66-35,1.16-78.13s.79-78.14.65-78.14-.66,35-1.16,78.13S349.4,357.09,349.54,357.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,232.11a3.81,3.81,0,0,0-.7-.61,16,16,0,0,0-2.12-1.38,20.5,20.5,0,0,0-3.44-1.51,21.91,21.91,0,0,0-9.09-1.06,20.69,20.69,0,0,0-3.7.7,15.13,15.13,0,0,0-2.37.85,3.29,3.29,0,0,0-.82.44c0,.09,1.24-.45,3.28-.95a24.43,24.43,0,0,1,3.65-.57,26.37,26.37,0,0,1,4.5.08,26.1,26.1,0,0,1,4.41,1,23.28,23.28,0,0,1,3.41,1.39C418.65,231.39,419.7,232.19,419.76,232.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.51,221.59s-.24-.09-.69-.14a11.32,11.32,0,0,0-1.93,0,15.45,15.45,0,0,0-11,5.71,10.46,10.46,0,0,0-1.07,1.59c-.22.4-.32.63-.29.65s.58-.82,1.64-2a17,17,0,0,1,4.86-3.79,17.34,17.34,0,0,1,5.91-1.79C411.51,221.59,412.51,221.68,412.51,221.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,231.66a8.27,8.27,0,0,0,1.33-.07l3.67-.36,12.55-1.4.23,0,0-.24c-.16-1.8-.34-3.72-.57-5.69-.73-6.41-1.58-12.19-2.23-16.36-.33-2.09-.61-3.78-.82-4.94-.1-.54-.18-1-.25-1.34a1.92,1.92,0,0,0-.12-.46,1.6,1.6,0,0,0,0,.48c0,.36.09.81.16,1.35.16,1.25.38,2.92.65,5,.56,4.19,1.35,10,2.09,16.37.22,2,.41,3.88.58,5.68l.22-.27L385,230.91l-3.65.51A8.31,8.31,0,0,0,380,231.66Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74,169.26a2.34,2.34,0,0,0,.4.14l1.18.35a13.72,13.72,0,0,1,4.23,2c1.65,1.21,3,3.4,4.16,6.06s2.12,5.86,3.26,9.35c2.23,7,4.79,15.36,7.53,24.68,2.47,9.35,6.66,19.49,5.88,30.8l0,1v0a13.82,13.82,0,0,1-3.42,6.61,18.15,18.15,0,0,1-6.32,3.66,47.06,47.06,0,0,1-6.94,1.83q-3.46.71-6.83,1.17c-2.24.32-4.43.5-6.58.62l-6.27.41-11.37.74.2.17c-.62-8.18-1.12-14.81-1.47-19.43-.18-2.28-.32-4-.42-5.29-.06-.58-.1-1-.13-1.37s-.06-.47-.06-.47a4.15,4.15,0,0,0,0,.47c0,.34,0,.79.07,1.38.07,1.24.18,3,.33,5.29.3,4.62.75,11.26,1.3,19.45V259h.18L390,258.3l6.27-.39c2.15-.11,4.38-.29,6.62-.6s4.54-.7,6.87-1.16a47.7,47.7,0,0,0,7-1.84,18.4,18.4,0,0,0,6.51-3.78,14.3,14.3,0,0,0,3.56-6.86v0c0-.31,0-.64,0-1,.08-5.59-.16-11.18-1.76-16.27-1.37-5.11-2.81-10-4.18-14.67-2.77-9.32-5.36-17.68-7.64-24.67-1.16-3.48-2.18-6.65-3.34-9.35s-2.59-4.88-4.31-6.1a13.18,13.18,0,0,0-4.31-1.95c-.52-.15-.92-.24-1.19-.3A3.44,3.44,0,0,0,399.74,169.26Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3,233.85c-.3-.3-6.08-4.3-6.08-4.3s-.33-2.78-1.82-3.27a4.86,4.86,0,0,0-4.65-2.48h-8.61l-7.42,8.32A2.12,2.12,0,0,0,357,234l-2,3.83s2.34,1.71,4.32.33S364,234.4,364,234.4l-4,6.23s.34,1.39,2.55.4a15,15,0,0,0,4.38-3.76l6.63-.7L368,238.45l-4.36,4s.4,1.39,2.38.89a16,16,0,0,0,4.26-2.07l3,.19a4.52,4.52,0,0,0,2.47,3.27,11,11,0,0,0,5.05,1l6.52,2.27C387.35,244.14,385.3,238.34,383.3,233.85Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,234a15.05,15.05,0,0,0,1.54-1.79,20,20,0,0,1,1.73-1.84,6.18,6.18,0,0,1,2.56-1.56,24.69,24.69,0,0,1,5.5-1.11,16.81,16.81,0,0,0,2.34-.27,7.94,7.94,0,0,0-2.36-.09,20.1,20.1,0,0,0-5.65,1,6,6,0,0,0-1.52.71,8.45,8.45,0,0,0-1.19,1,16,16,0,0,0-1.69,2A8.55,8.55,0,0,0,357,234Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,234.4c.07,0,.39-.31,1-.77a6.59,6.59,0,0,1,2.62-1.18,16.71,16.71,0,0,1,2.93-.31,3.23,3.23,0,0,0,1.25-.15c0-.07-.47-.15-1.24-.21a10.43,10.43,0,0,0-3.05.17,5.7,5.7,0,0,0-2.74,1.41C364.2,233.92,364,234.36,364,234.4Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.65,236c.05,0,.31-.15.54-.6a2.76,2.76,0,0,0-1-3.54c-.43-.27-.75-.3-.77-.24s1.08.63,1.45,2A4.8,4.8,0,0,1,378.65,236Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,244.24c-.09-.11-.77.3-1.67.64s-1.69.47-1.68.62.87.23,1.86-.15S384,244.34,383.9,244.24Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.11,231.71s.45.15,1.16.61a7,7,0,0,1,2.3,2.65,37.82,37.82,0,0,1,2,4.94,26.33,26.33,0,0,1,1.43,6.33,14.09,14.09,0,0,1-.54,5.33,9.63,9.63,0,0,1-2.3,4,8.59,8.59,0,0,1-2.94,2,7.74,7.74,0,0,1-2.16.53l-.31,0,.28.1a2.32,2.32,0,0,0,.72.21,3,3,0,0,0-.66-.34l0,.13a6.5,6.5,0,0,0,2.26-.4,8.55,8.55,0,0,0,3.13-2,10,10,0,0,0,2.47-4.09,14.3,14.3,0,0,0,.58-5.52,25.24,25.24,0,0,0-1.49-6.44,33.63,33.63,0,0,0-2.1-5,6.75,6.75,0,0,0-2.51-2.64,3.84,3.84,0,0,0-.92-.39C380.23,231.7,380.11,231.69,380.11,231.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,188.12a15.75,15.75,0,0,0-1.6,3.67,16,16,0,0,0-1.12,3.84,31.45,31.45,0,0,0,2.72-7.51Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,254.21a3.6,3.6,0,0,1,0-.68q0-.75.06-1.95c.06-1.75.14-4.18.23-7.15.17-6,.29-14.39.26-23.61s-.13-17.53-.18-23.63c0-3,0-5.4,0-7.16,0-.8,0-1.44,0-1.94a3.22,3.22,0,0,1,0-.68,3,3,0,0,1,.06.68c0,.49.05,1.14.08,1.94,0,1.75.11,4.18.19,7.16.14,6,.31,14.39.33,23.62s-.15,17.59-.41,23.63c-.13,3-.27,5.46-.4,7.15-.06.8-.11,1.45-.15,1.94A3,3,0,0,1,315.76,254.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,224.2a4.42,4.42,0,0,1-2.09-.31c-1.11-.3-2-.66-1.94-.8a4.45,4.45,0,0,1,2.08.3C313.79,223.7,314.67,224.06,314.63,224.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.55,199.27s-2.09-4.16-4.3-4.11c-1.48,0-2.48,3.45-2.48,3.45s-2.9-2.07-4,0,1,5.24,1,5.24-2.21,1.24-2.49,3a12.51,12.51,0,0,0,0,3.45,5.33,5.33,0,0,0-.69,3.86c.56,1.93,5.66,9.79,5.66,9.79l5.65,3.18,1.24,4.24c5.4-1.06,8.12-3.35,8.72-9.82,0,0,3.7-11,3-13s-4.14-4.83-4.14-4.83l-2.73-2a4.57,4.57,0,0,0-1.09,2.83c0,1.66-.32,1.54-.32,1.54Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,203.21a5.1,5.1,0,1,1-5.1-5.11A5.1,5.1,0,0,1,304.11,203.21Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,203.21c-.05,0,0-.46-.25-1.22A5.14,5.14,0,0,0,302,199.3a4.88,4.88,0,1,0,0,7.82,5.18,5.18,0,0,0,1.87-2.69c.21-.77.2-1.22.25-1.22s0,.11,0,.33a3.68,3.68,0,0,1-.1.94,5.05,5.05,0,0,1-1.84,2.93,5.25,5.25,0,0,1-5,.82,5.31,5.31,0,0,1-2.5-1.85,5.31,5.31,0,0,1,0-6.34,5.31,5.31,0,0,1,7.52-1,5.1,5.1,0,0,1,1.84,2.94,3.64,3.64,0,0,1,.1.94C304.14,203.1,304.13,203.21,304.11,203.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,208a4.75,4.75,0,1,1,4.75-4.75A4.75,4.75,0,0,1,299,208Zm0-8.5a3.75,3.75,0,1,0,3.75,3.75A3.75,3.75,0,0,0,299,199.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,247.17a10.78,10.78,0,0,1-1.51-.08c-8.56-.87-15.48-7.72-20-19.79a78.68,78.68,0,0,1-4.24-17.87l2-.19c0,.34,3.51,33.93,22.49,35.87.56.07,13,1.57,16.47-12.28a147.25,147.25,0,0,0,3.54-24.56c.26-3.92,1.73-16.48,2.43-21.15l.69-4.2,2,.32-.69,4.19c-.7,4.62-2.16,17.09-2.41,20.95a149.44,149.44,0,0,1-3.6,24.93C338.94,245.93,328.83,247.17,325,247.17Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.58,203.85s.33-.19,1-.12a2.71,2.71,0,0,1,1.1.42,14.21,14.21,0,0,1,1.23.89,37.71,37.71,0,0,1,3,2.6,20.18,20.18,0,0,1,1.61,1.69,6.21,6.21,0,0,1,.71,1.07,1.5,1.5,0,0,1,.07,1.45,1.94,1.94,0,0,1-1.32.78,4.73,4.73,0,0,1-1.4.07l.26-.36a1.73,1.73,0,0,1-.29,1.43,4.29,4.29,0,0,1-.85.95,1.89,1.89,0,0,1-1.2.37,4.23,4.23,0,0,1-1.09-.13,11.89,11.89,0,0,1-3.11-1.28h.14a8,8,0,0,1-1.48.8,8.15,8.15,0,0,1,1.34-1l.05,0,.08,0a13.15,13.15,0,0,0,3.06,1.11,2.46,2.46,0,0,0,1.91-.21,3.56,3.56,0,0,0,.73-.85,1.41,1.41,0,0,0,.25-.95l-.13-.38.39,0c.76.05,1.8,0,2.22-.61a1.05,1.05,0,0,0-.09-1,5.07,5.07,0,0,0-.65-1,18,18,0,0,0-1.55-1.68c-1-1-2-1.94-2.85-2.66a5.71,5.71,0,0,0-2.14-1.39A5.82,5.82,0,0,0,290.58,203.85Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,213.21c-.08,0-.27-.67-.94-1.59s-1.81-2-2.79-3.58a5.16,5.16,0,0,1-.79-2.46,5.55,5.55,0,0,1,.35-2.08,4.1,4.1,0,0,1,.91-1.66c.07,0-.25.68-.56,1.77a6.09,6.09,0,0,0-.22,1.94,4.91,4.91,0,0,0,.76,2.22c.91,1.45,2.07,2.61,2.65,3.65A3.18,3.18,0,0,1,308,213.21Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.55,212.45c-.05.06-.55-.31-1.25-1-.18-.16-.38-.34-.6-.52l-.73-.52-1.66-1.22a3.33,3.33,0,0,0-1.82-.56,2.67,2.67,0,0,0-1.46.53,3,3,0,0,0-.94,1.14s-.07-.16,0-.44a2.19,2.19,0,0,1,.7-1,2.9,2.9,0,0,1,1.66-.72,3.53,3.53,0,0,1,2.13.61c.63.44,1.17.88,1.68,1.28l.72.57c.21.2.4.4.57.58A6.41,6.41,0,0,1,296.55,212.45Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,200.21c-.14,0-.37-.35-.63-.82s-.47-.87-.36-1,.52.19.81.72S295,200.17,294.87,200.21Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.23,230a31.36,31.36,0,0,1-3.3-4.66,31.4,31.4,0,0,1-2.87-5,31.15,31.15,0,0,1,3.3,4.67A31.07,31.07,0,0,1,315.23,230Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,184.58l-.3-.16c-.23-.11-5.67-2.91-8.23-6.72s3-20.67,4.12-24l1.89.65c-2.7,7.89-5.84,20-4.35,22.23,2,2.92,6.06,5.29,7.19,5.91,3-.56,10-2.12,11.95-3.62,2.78-2.11,10.92-16.55,13.82-21.93l1.76.95c-1.09,2-10.75,19.81-14.37,22.57-2.81,2.14-12.1,3.87-13.15,4.06Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.51,93.56c3.38-3.27,11.15-2.23,12.85.18a6,6,0,0,1,7.62,3.1l8.18,2.36a8.63,8.63,0,0,1,3.88,1.87c1,1,1.42,2.84.44,3.92,2.88,1,3.74,5.38,1.43,7.34a3.16,3.16,0,0,1-.76,4.52,31.44,31.44,0,0,1,4.73,9.59,6.42,6.42,0,0,1,.13,4.4c-.61,1.37-2.52,2.22-3.68,1.26a3.7,3.7,0,0,1-.08,4c1.4.13,1.67,2.32.64,3.28s-2.6,1-4,.84-2.91-.3-4.12.43a1.28,1.28,0,0,0,.4.92,5.79,5.79,0,0,1,.77,7.95l-.5.61c-.89,1.1-3,2-4.27,2.6-3.28,1.44-5.15,1-8.73,1.29.82,2.35-5.27,7-11.53,1.62a127.15,127.15,0,0,1-36.55,2.53c-1.94-.12-4.26-.54-5-2.33a4.84,4.84,0,0,1-4.34-1.75,14.18,14.18,0,0,1-2.33-4.27,8.49,8.49,0,0,1-5.59-8,10.51,10.51,0,0,1-3.46-7.69,6.16,6.16,0,0,1-3-8.52,36.88,36.88,0,0,1,4.79-11.19c-2.19-.63-2.84-3.68-1.78-5.71s3.16-3.23,5.16-4.33c-1.69.33-3-1.85-2.5-3.5s2.09-2.71,3.63-3.5a31.07,31.07,0,0,1,7.1-2.62c1-2.88,4.95-6,7.78-7.09,11.41-4.51,19.25-5.32,32.68,5.93",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,134.3a4,4,0,0,0-1.5-1.19h.12c-.11,0-.22-.06-.33-.09a1.62,1.62,0,0,0-1.26,0h0a3,3,0,0,0-1.73,1.26,3.49,3.49,0,0,0,.09,3.63,2.67,2.67,0,0,0,5-.48A3.31,3.31,0,0,0,336.06,134.3Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.3,112.63c1.38-7.56,7.54-16.31,15-14.61l23,8.8a4.5,4.5,0,0,1,3.46,5l-7.09,49.4-18.29,13.45h0c-.15-1-8.05-13.45-8.05-13.45-.41-3.68-.83-7.75-.83-7.73s-9.54-2.77-10-15.71C333.22,131.35,334.77,121,336.3,112.63Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.6,123.33a1.64,1.64,0,0,0,1.37,1.83,1.58,1.58,0,0,0,1.86-1.27,1.64,1.64,0,0,0-1.38-1.83A1.56,1.56,0,0,0,337.6,123.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,118.28c.18.24,1.52-.53,3.27-.32s2.93,1.25,3.15,1.05-.06-.49-.57-1a4.55,4.55,0,0,0-2.49-1.11,4.39,4.39,0,0,0-2.63.52C338.05,117.81,337.82,118.18,337.91,118.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.56,124.85a1.65,1.65,0,0,0,1.38,1.83,1.57,1.57,0,0,0,1.85-1.27,1.64,1.64,0,0,0-1.38-1.83A1.56,1.56,0,0,0,353.56,124.85Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.1,120.65c.17.24,1.52-.53,3.27-.32s2.93,1.24,3.15,1-.06-.49-.57-1a4.55,4.55,0,0,0-2.49-1.1,4.31,4.31,0,0,0-2.63.52C355.24,120.18,355,120.54,355.1,120.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2,132.89a12,12,0,0,0-2.79-.85c-.44-.1-.85-.24-.89-.55a2.3,2.3,0,0,1,.45-1.29L345.7,127c2.41-4.64,4.22-8.47,4-8.56s-2.3,3.58-4.71,8.21c-.58,1.15-1.14,2.24-1.67,3.28a2.6,2.6,0,0,0-.44,1.73,1.12,1.12,0,0,0,.66.74,3,3,0,0,0,.74.2A11.6,11.6,0,0,0,347.2,132.89Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53,153.49A32.59,32.59,0,0,0,361.08,151s-3.93,8.87-17.11,6.61Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,137.09a4.34,4.34,0,0,1,3.78-1.46,2.8,2.8,0,0,1,2.15,1.53,2.59,2.59,0,0,1-3.34,3.51,6.45,6.45,0,0,1-2.39-1.9,2.07,2.07,0,0,1-.48-.72.88.88,0,0,1,.18-.88",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.21,134.72c-.28-.05-.51,1.85-2.3,3s-3.79.7-3.83,1c0,.11.41.42,1.26.55a4.83,4.83,0,0,0,3.19-.71,4.1,4.1,0,0,0,1.8-2.54C352.5,135.22,352.34,134.72,352.21,134.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.18,113.34c.11.5,1.89.48,3.92,1s3.62,1.25,3.94.86c.15-.19-.09-.68-.7-1.22a6.67,6.67,0,0,0-2.84-1.38,6.79,6.79,0,0,0-3.15,0C355.55,112.78,355.13,113.11,355.18,113.34Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.24,112.32c.26.44,1.52.17,3,.32s2.65.59,3,.2c.15-.18,0-.61-.49-1a4.33,4.33,0,0,0-4.79-.41C339.35,111.72,339.13,112.11,339.24,112.32Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.13,118.33a8.77,8.77,0,0,1,2.51-5.33,30.08,30.08,0,0,0,2.53-2.11c1.57-1.78,1.56-4.41,2.34-6.65a9.67,9.67,0,0,1,6.44-6c2.45-.68,5.15-.36,7.48-1.39,1.72-.76,3.1-2.19,4.86-2.85,3.44-1.27,7.17.72,10.17,2.82.44,2.54-1.29,4.58-3,6.54a8.91,8.91,0,0,1-6.81,3.09c-2,0-4.29-.64-5.8.67s-1.2,4.06-2.54,5.69c-1.91,2.32-5.77,1.1-8.47,2.42-2.09,1-3.1,3.35-4.26,5.37s-3.06,4-5.36,3.77A25.64,25.64,0,0,1,330.13,118.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,101A45.16,45.16,0,0,1,378,105.29a8.28,8.28,0,0,1,4,3.21,8.11,8.11,0,0,1,.56,4.48c-.4,4.77-2.76,10.47-4.9,14.75l-6.22,3.13c-4.51-1.42-1.82-9.19-1.31-13.15a9.39,9.39,0,0,1-4.87-8.68A10.43,10.43,0,0,1,361.16,101Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.65,129.15c.38-2.71,3.77-3,6-1.42,1.23.87,2.09,2.47,1.71,5.35-1,7.7-8.53,5.1-8.51,4.88S371.2,132.33,371.65,129.15Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,135.35s.12.11.33.24a1.39,1.39,0,0,0,1,.16c.86-.2,1.71-1.4,1.93-2.78a4.59,4.59,0,0,0-.12-2,1.58,1.58,0,0,0-.88-1.16.7.7,0,0,0-.84.26c-.13.21-.1.37-.14.37s-.15-.15-.05-.46a.89.89,0,0,1,.37-.44,1,1,0,0,1,.77-.1,1.9,1.9,0,0,1,1.24,1.38,4.49,4.49,0,0,1,.18,2.21c-.25,1.54-1.23,2.89-2.39,3.06a1.46,1.46,0,0,1-1.2-.36C373.58,135.54,373.56,135.36,373.59,135.35Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.79,137.39a4.07,4.07,0,0,0-1.5-1.18h.12a2,2,0,0,0-.33-.09,1.62,1.62,0,0,0-1.26,0h0a3,3,0,0,0-1.73,1.26,3.49,3.49,0,0,0,.08,3.62,2.67,2.67,0,0,0,5-.47A3.34,3.34,0,0,0,377.79,137.39Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.21,138.66a.87.87,0,0,0,0,.11,1.74,1.74,0,0,0,.09.3,1.8,1.8,0,0,0,.83.87,4.71,4.71,0,0,0,1.89.53,6.34,6.34,0,0,0,1.24,0,4.85,4.85,0,0,0,1.39-.31l-.09-.06a3.85,3.85,0,0,0,5.94,2.89l-.13,0a1.61,1.61,0,0,0,1,.75,2.16,2.16,0,0,0,1.26,0,2,2,0,0,0,1.07-.74,2.67,2.67,0,0,0,.49-1.25,3.93,3.93,0,0,0-.66-2.64,11.19,11.19,0,0,0-1.89-2.13l0,.18A2.81,2.81,0,0,0,388,135.4a4,4,0,0,0-.06-2.3,6.09,6.09,0,0,0-1.21-2,19.39,19.39,0,0,0-1.71-1.68v.17a2.89,2.89,0,0,0,.92-2.18,4.16,4.16,0,0,0-.7-2.36,10.32,10.32,0,0,0-3.58-2.91l.06.14a5.15,5.15,0,0,0-5.11-6.75l.11.14a4.48,4.48,0,0,0-.77-3.84,4.37,4.37,0,0,0-3.15-1.84l.09.1a4.4,4.4,0,0,0-1.5-3.5,4.32,4.32,0,0,0-3.17-1.13l.08.09a4.2,4.2,0,0,0-.48-2A5.47,5.47,0,0,0,366.7,102a4.46,4.46,0,0,0-2.56-1.33l-.29,0a2.43,2.43,0,0,0-.27,0,3.78,3.78,0,0,0-.49,0,5.1,5.1,0,0,0-.76.15l-.44.15-.15.06s.05,0,.16,0l.44-.13a5.47,5.47,0,0,1,.75-.13,3.92,3.92,0,0,1,.49,0h.27l.28,0a4.38,4.38,0,0,1,2.49,1.34,5.27,5.27,0,0,1,1,1.48,4.09,4.09,0,0,1,.45,2v.09h.08a4.08,4.08,0,0,1,3,1.1,4.22,4.22,0,0,1,1.43,3.36v.09h.1a4.2,4.2,0,0,1,3,1.78,4.25,4.25,0,0,1,.73,3.65l0,.15h.16a4.91,4.91,0,0,1,4.87,6.45l0,.09.09,0a10.13,10.13,0,0,1,3.49,2.84,3.88,3.88,0,0,1,.67,2.22,2.7,2.7,0,0,1-.85,2l-.1.08.1.09a9.18,9.18,0,0,1,2.87,3.61,3.79,3.79,0,0,1,.05,2.16,2.52,2.52,0,0,1-1.24,1.61l-.14.07.11.11a11,11,0,0,1,1.86,2.09,3.71,3.71,0,0,1,.63,2.5,2.07,2.07,0,0,1-1.4,1.83,1.72,1.72,0,0,1-2-.64l-.05-.09-.08.05a3.77,3.77,0,0,1-3.92.09,3.82,3.82,0,0,1-1.8-2.84V140l-.08,0a4.47,4.47,0,0,1-1.35.31,7.14,7.14,0,0,1-1.22,0,4.92,4.92,0,0,1-1.86-.5,1.79,1.79,0,0,1-.84-.83A2.31,2.31,0,0,1,374.21,138.66Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.26,132.54a2.25,2.25,0,0,0,.33-.44,4.21,4.21,0,0,0,.52-1.5,3.9,3.9,0,0,0-.46-2.48,4.12,4.12,0,0,0-2.67-2l.06.09a5.25,5.25,0,0,0-.42-3.86,5.18,5.18,0,0,0-1.39-1.72,12.32,12.32,0,0,0-2-1.15,4.13,4.13,0,0,1-1-.68,2.5,2.5,0,0,1-.64-1c-.29-.76-.33-1.65-.71-2.48a4.71,4.71,0,0,0-4.54-2.68l.13.14a6.21,6.21,0,0,0-6.35-7.52l.12.14a5.45,5.45,0,0,0-8.08-5.7l.12,0a7.48,7.48,0,0,0-2.58-1.85,11.38,11.38,0,0,0-2.73-.84,12.89,12.89,0,0,0-4.6,0,9.22,9.22,0,0,0-2.81.93,4.69,4.69,0,0,0-.66.41l-.22.15s.31-.2.91-.51a9.77,9.77,0,0,1,2.8-.87,13,13,0,0,1,4.55.07,10.94,10.94,0,0,1,2.68.85,7.15,7.15,0,0,1,2.51,1.81l.05.06.07,0a5.42,5.42,0,0,1,5.38.1,5.36,5.36,0,0,1,2.38,5.39l0,.14h.14a6,6,0,0,1,6.11,7.24l0,.16.15,0a4.5,4.5,0,0,1,4.32,2.54c.36.78.41,1.66.71,2.47a2.82,2.82,0,0,0,.69,1.07,4.35,4.35,0,0,0,1,.71,13.39,13.39,0,0,1,2,1.12,5.06,5.06,0,0,1,1.35,1.65,5.13,5.13,0,0,1,.43,3.74l0,.08.08,0a4,4,0,0,1,2.6,1.89,3.88,3.88,0,0,1,.48,2.4,4.17,4.17,0,0,1-.48,1.49C404.37,132.39,404.25,132.53,404.26,132.54Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.18,129.25a.74.74,0,0,0,.08-.63,1.67,1.67,0,0,0-.41-.68,2.65,2.65,0,0,0-.92-.55,4.29,4.29,0,0,1-1.17-.59,2.38,2.38,0,0,1-.78-1.3,4.63,4.63,0,0,1-.06-1.79c.07-.63.22-1.3.27-2a21,21,0,0,0-.65-4.65,6.41,6.41,0,0,1,.08-2.54,3.14,3.14,0,0,1,1.56-2.08,11.92,11.92,0,0,1,2.78-.72,4.53,4.53,0,0,0,1.43-.54,3.11,3.11,0,0,0,1.07-1.15,14.88,14.88,0,0,0,1-3,5.23,5.23,0,0,1,.65-1.42,2.36,2.36,0,0,1,1.21-.92,8.55,8.55,0,0,1,2.16-.13,3.45,3.45,0,0,0,1.1-.2,2,2,0,0,0,.91-.66,7.57,7.57,0,0,0,1-1.91,4.76,4.76,0,0,1,1.1-1.68,4.67,4.67,0,0,1,3.48-1.36,4.78,4.78,0,0,1,3.2,1.43l.09.1.07-.12a7.36,7.36,0,0,1,4.88-3.63,6.72,6.72,0,0,1,2.6,0,6.24,6.24,0,0,1,2.08.75,5.46,5.46,0,0,1,2.11,2.24,7,7,0,0,1,.33.75l.07.2s0,.07,0,.07l0-.07-.06-.21a4.87,4.87,0,0,0-.31-.77,5.38,5.38,0,0,0-2.1-2.31,6.2,6.2,0,0,0-2.12-.79,7,7,0,0,0-2.65,0,7.55,7.55,0,0,0-5,3.7l.16,0a5,5,0,0,0-3.33-1.51,5,5,0,0,0-4.8,3.17,7.8,7.8,0,0,1-.92,1.85,2.26,2.26,0,0,1-1.84.77,8.86,8.86,0,0,0-2.22.15,2.64,2.64,0,0,0-1.34,1,5.38,5.38,0,0,0-.67,1.49,14.75,14.75,0,0,1-1,2.94,2.94,2.94,0,0,1-1,1.08,4.65,4.65,0,0,1-1.36.51,11.94,11.94,0,0,0-2.83.75,3,3,0,0,0-1.08.94,3.94,3.94,0,0,0-.58,1.27,6.69,6.69,0,0,0-.07,2.63,21.2,21.2,0,0,1,.67,4.6c0,.71-.18,1.38-.25,2a4.83,4.83,0,0,0,.08,1.83,2.54,2.54,0,0,0,.84,1.36,4.63,4.63,0,0,0,1.21.59,2.56,2.56,0,0,1,.9.51,1.5,1.5,0,0,1,.41.64A1,1,0,0,1,330.18,129.25Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.05,116.18l.09-.14.24-.41.92-1.62c.4-.7.86-1.58,1.5-2.53a6.84,6.84,0,0,1,2.79-2.59c.65-.29,1.39-.46,2.14-.73a5.6,5.6,0,0,0,1.1-.54,2.75,2.75,0,0,0,.86-1c.42-.77.5-1.68.85-2.49a2.13,2.13,0,0,1,.83-1,4.09,4.09,0,0,1,1.28-.48,8.32,8.32,0,0,0,1.4-.43,2.45,2.45,0,0,0,1.14-1,11.16,11.16,0,0,0,.88-2.95,3.67,3.67,0,0,1,.62-1.38A1.92,1.92,0,0,1,334,96.2c1-.14,2.1.29,3.25.2a2.81,2.81,0,0,0,1.54-.68,7.38,7.38,0,0,0,1.06-1.26,12.35,12.35,0,0,1,.95-1.27,3,3,0,0,1,1.2-.89,4.52,4.52,0,0,1,2.92.23,6.7,6.7,0,0,0,2.92.47,8,8,0,0,0,2.64-1,13.15,13.15,0,0,1,2.36-1.1,7.92,7.92,0,0,1,4.6.19,8.48,8.48,0,0,1,3.27,2,9.83,9.83,0,0,1,1.72,2.36,11.58,11.58,0,0,1,.68,1.72c.06.19.11.35.14.46l.06.16s0-.06,0-.16-.07-.28-.13-.47a9.81,9.81,0,0,0-.64-1.75,9.59,9.59,0,0,0-1.7-2.41A8.75,8.75,0,0,0,357.47,91a8.19,8.19,0,0,0-4.71-.22,13.69,13.69,0,0,0-2.41,1.1,7.65,7.65,0,0,1-2.57,1,6.7,6.7,0,0,1-2.82-.47,9,9,0,0,0-1.49-.37,3.16,3.16,0,0,0-1.58.13,3.32,3.32,0,0,0-1.3,1c-.36.41-.65.86-1,1.29a7.1,7.1,0,0,1-1,1.22,2.51,2.51,0,0,1-1.42.62c-1.06.1-2.13-.34-3.25-.2a2.15,2.15,0,0,0-1.43.81,3.82,3.82,0,0,0-.66,1.47,11.72,11.72,0,0,1-.85,2.89,2.29,2.29,0,0,1-1,.93,7.11,7.11,0,0,1-1.36.41,4.35,4.35,0,0,0-1.35.52,2.46,2.46,0,0,0-.9,1.1c-.36.85-.43,1.75-.83,2.48a3.18,3.18,0,0,1-1.86,1.42c-.73.26-1.47.44-2.14.75a6.91,6.91,0,0,0-2.83,2.66c-.63,1-1.08,1.86-1.47,2.56s-.67,1.26-.88,1.64c-.09.18-.17.32-.22.43S316,116.18,316.05,116.18Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.87,108.69l-.14,0a.76.76,0,0,0-.42.06,1.66,1.66,0,0,0-.87,1.31,4,4,0,0,0,.08,1.17,4.58,4.58,0,0,1,.1,1.35,3,3,0,0,1-.65,1.39c-.33.45-.75.87-1.1,1.41a2.24,2.24,0,0,0-.33,1.93c.2.68.64,1.26.82,2a2.91,2.91,0,0,1-.36,2.11c-.36.68-.84,1.34-1.19,2.1a3.46,3.46,0,0,0-.34,1.24,3.22,3.22,0,0,0,.2,1.3,15.07,15.07,0,0,0,1.31,2.31,3.59,3.59,0,0,1,.64,2.51,12.29,12.29,0,0,1-1.13,2.54,4,4,0,0,0-.39,1.4,3.19,3.19,0,0,0,.26,1.41,12,12,0,0,0,1.51,2.31,6.36,6.36,0,0,1,1.19,2.29,18.47,18.47,0,0,0,.63,2.46,2.76,2.76,0,0,0,.71,1,3.6,3.6,0,0,0,1.05.61,9.22,9.22,0,0,1,1.05.46,3.7,3.7,0,0,1,.85.67,8.08,8.08,0,0,1,1.14,1.75c.32.6.6,1.19.94,1.72a5.26,5.26,0,0,0,2.55,2.18,5.75,5.75,0,0,0,2.5.43,5.15,5.15,0,0,0,1.58-.34,3.7,3.7,0,0,0,.5-.24,5.92,5.92,0,0,1-2.08.49,5.72,5.72,0,0,1-2.45-.46,5.15,5.15,0,0,1-2.46-2.14c-.32-.53-.6-1.12-.91-1.73a8.21,8.21,0,0,0-1.17-1.79,3.9,3.9,0,0,0-.89-.72,10.27,10.27,0,0,0-1.07-.48,3.27,3.27,0,0,1-1-.57,2.48,2.48,0,0,1-.65-1,18.51,18.51,0,0,1-.61-2.44,6.56,6.56,0,0,0-1.23-2.37,11.24,11.24,0,0,1-1.47-2.26,2.81,2.81,0,0,1-.24-1.31,3.44,3.44,0,0,1,.37-1.31,11.86,11.86,0,0,0,1.14-2.6,3,3,0,0,0-.09-1.42,5.94,5.94,0,0,0-.58-1.25,14.51,14.51,0,0,1-1.3-2.27,3,3,0,0,1-.19-1.21,3.4,3.4,0,0,1,.32-1.16c.33-.74.81-1.39,1.17-2.1a3,3,0,0,0,.37-2.25c-.21-.74-.65-1.32-.84-2a2,2,0,0,1,.31-1.79c.33-.52.74-1,1.07-1.41a3,3,0,0,0,.66-1.46,4.74,4.74,0,0,0-.12-1.39,4.23,4.23,0,0,1-.1-1.14,1.62,1.62,0,0,1,.8-1.28A1.17,1.17,0,0,1,324.87,108.69Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.09,132.27a2.82,2.82,0,0,0,.61,0,4.23,4.23,0,0,0,1.68-.58,4.1,4.1,0,0,0,1.8-2.16,4.34,4.34,0,0,0-.36-3.69,10.3,10.3,0,0,0-1.43-1.71,5.13,5.13,0,0,1-1.31-1.94,3.43,3.43,0,0,1,.31-2.45c.35-.81.87-1.58,1.22-2.48a7.6,7.6,0,0,0-5-10.07l.06.18a3.93,3.93,0,0,0,.8-1.64,5,5,0,0,0,0-1.84,5.49,5.49,0,0,0-.65-1.76,6.77,6.77,0,0,0-1.21-1.46,12,12,0,0,0-4.94-2.43,17.85,17.85,0,0,0-5.18-.61l.12.12a5.51,5.51,0,0,0-2.75-5A5.61,5.61,0,0,0,385.2,92a9.08,9.08,0,0,0-2.59.48,5.06,5.06,0,0,1-1.21.18,3,3,0,0,1-1.15-.21,9.3,9.3,0,0,1-2-1.14,8,8,0,0,0-1.89-1,6.87,6.87,0,0,0-1.94-.41,6.45,6.45,0,0,0-3.27.64,6.63,6.63,0,0,0-2,1.49,6.25,6.25,0,0,0-.91,1.27,3.36,3.36,0,0,0-.23.49s.08-.17.26-.47a7.13,7.13,0,0,1,.93-1.24,6.66,6.66,0,0,1,2-1.44,6.49,6.49,0,0,1,5.1-.18,7.92,7.92,0,0,1,1.85,1,9.58,9.58,0,0,0,2,1.18,3.34,3.34,0,0,0,1.22.22,5.32,5.32,0,0,0,1.26-.18,8.71,8.71,0,0,1,2.54-.47,5.43,5.43,0,0,1,2.57.71,5.28,5.28,0,0,1,2.63,4.79v.12h.12a18.08,18.08,0,0,1,5.11.61,11.77,11.77,0,0,1,4.84,2.39,6.27,6.27,0,0,1,1.17,1.4,5.09,5.09,0,0,1,.62,1.68,4.68,4.68,0,0,1,0,1.75,3.58,3.58,0,0,1-.75,1.54l-.11.14.17.05a7.39,7.39,0,0,1,4.87,9.78c-.34.87-.85,1.65-1.21,2.47a3.6,3.6,0,0,0-.3,2.58,5.42,5.42,0,0,0,1.36,2,10.77,10.77,0,0,1,1.42,1.67,4.21,4.21,0,0,1,.38,3.57,4.08,4.08,0,0,1-1.73,2.13,4.24,4.24,0,0,1-1.64.61C404.3,132.27,404.09,132.26,404.09,132.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,103.18s0-.05,0-.15l.07-.43c.07-.39.16-.95.28-1.66s.3-1.59.57-2.59a14.76,14.76,0,0,1,1.26-3.26,9.9,9.9,0,0,1,2.72-3.2,7.41,7.41,0,0,1,2.07-1.08,21.76,21.76,0,0,1,2.46-.52,7,7,0,0,0,2.51-.9,10.7,10.7,0,0,0,2.12-1.81c.65-.68,1.28-1.4,2-2A7.55,7.55,0,0,1,341.07,84a13.92,13.92,0,0,1,5.68-.78,36.11,36.11,0,0,1,5.36.62,27.48,27.48,0,0,1,8.55,3.08,19.32,19.32,0,0,1,4.79,3.84c.24.27.46.51.64.73l.43.56.27.35.09.11s0,0-.07-.12l-.25-.36-.41-.59-.63-.74a18.77,18.77,0,0,0-4.77-3.92,27.69,27.69,0,0,0-8.6-3.16,36.48,36.48,0,0,0-5.4-.63,14.11,14.11,0,0,0-5.77.79,8,8,0,0,0-2.51,1.58c-.73.66-1.36,1.38-2,2.06a10.74,10.74,0,0,1-2.06,1.78,6.69,6.69,0,0,1-2.45.88,21.62,21.62,0,0,0-2.47.53,7.33,7.33,0,0,0-2.13,1.12A10.07,10.07,0,0,0,324.61,95a14.71,14.71,0,0,0-1.25,3.31,25.73,25.73,0,0,0-.53,2.61c-.12.72-.19,1.28-.24,1.66,0,.18,0,.33,0,.44S322.53,103.18,322.53,103.18Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character-1",
    "data-motion": "breathe",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.57,450.39s1,6.43,1,7.56l4.56,3.9,11.55-2.58,1-9.45Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89,457.86l0,1s17.47,6.78,17.69,10.07l-34.53.24.39-11.49A19.79,19.79,0,0,0,146.89,457.86Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.07,469.19l.1-2.76,33.06.78s1.54.66,1.37,1.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147,459c0,.17-.85.25-1.68.8s-1.26,1.26-1.41,1.19.08-1,1.1-1.69S147.06,458.82,147,459Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.66,460.45c0,.16-.69.46-1.26,1.17s-.73,1.48-.89,1.47-.28-1,.44-1.84S150.65,460.29,150.66,460.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.75,464.77c-.16,0-.4-.8,0-1.73s1.21-1.3,1.28-1.16-.41.64-.75,1.4S152.91,464.75,152.75,464.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.18,450.39s1,6.43,1,7.56l4.56,3.9,11.56-2.58.95-9.45Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.49,457.86l0,1S202,465.66,202.21,469l-34.53.24.39-11.49A19.77,19.77,0,0,0,184.49,457.86Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.68,469.19l.09-2.76,33.06.78s1.54.66,1.38,1.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,459c0,.17-.85.25-1.67.8s-1.27,1.26-1.42,1.19.09-1,1.1-1.69S184.67,458.82,184.63,459Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,460.45c0,.16-.69.46-1.25,1.17s-.73,1.48-.9,1.47-.28-1,.44-1.84S188.26,460.29,188.26,460.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.35,464.77c-.15,0-.39-.8,0-1.73s1.21-1.3,1.29-1.16-.42.64-.75,1.4S190.52,464.75,190.35,464.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.22 289.15 120.32 289.15 112.47 325.09 128.15 452.88 152.43 452.88 157.98 340.32 163.83 452.88 189.85 452.88 200.78 326.51 196.22 289.15",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19,451.09c-.13,0-.46-22.52-.73-50.3s-.4-50.3-.27-50.3.46,22.51.74,50.3S138.32,451.09,138.19,451.09Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,450.66a.84.84,0,0,1,0-.28c0-.21,0-.48.07-.82.09-.76.2-1.82.35-3.16.31-2.74.73-6.71,1.2-11.62s1-10.77,1.38-17.28.77-13.66,1-21.19.24-14.69.2-21.22-.22-12.39-.43-17.32-.38-8.92-.55-11.67c-.07-1.35-.12-2.41-.16-3.17,0-.34,0-.62,0-.83a2,2,0,0,1,0-.28.87.87,0,0,1,.05.28c0,.21,0,.48.07.82.06.76.15,1.82.26,3.17.22,2.75.46,6.74.7,11.67s.42,10.8.52,17.33,0,13.7-.16,21.24-.59,14.69-1,21.2-1,12.37-1.49,17.28-1,8.87-1.35,11.61c-.18,1.34-.33,2.4-.43,3.15l-.12.82A1,1,0,0,1,177.07,450.66Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15,173.84l-29,1.57-2.37,10.92s8,6.42,8.8,6.69,19,2.81,19,2.81,19.62-9.14,19.35-9.06S155.15,173.84,155.15,173.84Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89,173.74c1.14,0,13.37-1.63,20.84,3.29s27.53,43,27.53,43,6.12,20.27-2.49,24.28-31.35,16.25-31.35,16.25l-5.54-20.07,15.68-7.26V213.88Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,187s11,6.38,19.42,4.52a32.87,32.87,0,0,0,14.32-7.71l14.81,33.92-8.78,68-26.47,3.46-8.77-64.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33,175l-5.75,2L111,246.39s-8.24,28.89-7.49,41.37,7.45,51.15,7.45,51.15l48.51-5.12-2-75.9s3.49-21.84-6.87-35.07S127.33,175,127.33,175Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15,173.49c.67.95,11.28,41.26,10.14,49.74S158,249.51,158,249.51v84l42.8-3.91s3.51-30.68,0-45.37-8.61-32.1-8.61-32.1l-3.38-51.29-21.54-27.39Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,246.38c.23-.08,7.62-4.12,9.48-4.36s16.38-.94,16.38-.94l3.88,14s-12.09,5.86-14,6.33-9.79,3.34-11.11,3.34-5.06-1.24-5.06-2.1a1.33,1.33,0,0,1,.55-1.17,26.09,26.09,0,0,0,5.05-.31,24,24,0,0,0,2.56-1.08s-13.29,2-14.22,1.71-1.63-2.27-1.63-2.27-1.56-1.08-1.71-2.09.39-1.47,1.24-1.86,6.61-3,8.32-3.42,6.22-1.25,6.22-1.25-13.68,1.48-14.54,1.09-1.79-1.86-.39-2.72a19.36,19.36,0,0,1,5.52-2.41C143.33,246.69,145.19,246.38,145.19,246.38Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.92,254.74a13.74,13.74,0,0,1-2.56,1c-1.62.57-3.87,1.28-6.41,1.92s-4.85,1.08-6.54,1.34a14.86,14.86,0,0,1-2.76.3,18.56,18.56,0,0,1,2.7-.63c1.67-.34,4-.84,6.49-1.47s4.78-1.29,6.41-1.78A21.48,21.48,0,0,1,154.92,254.74Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,244.28a19.51,19.51,0,0,1-4.12,1.17,19.79,19.79,0,0,1-4.23.7,19.28,19.28,0,0,1,4.12-1.17A19.7,19.7,0,0,1,153.64,244.28Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.34,246.7s-.21,0-.55.07a5.15,5.15,0,0,0-1.39.55,4.56,4.56,0,0,1-2.24.72c-.92-.06-1.83-.56-2.54.05a7.09,7.09,0,0,1-1.19.89,2.46,2.46,0,0,1-1.45.14c-.89-.17-1.58-.52-2.19-.56a1.79,1.79,0,0,0-1.34.39c-.25.22-.31.43-.35.41s0-.23.22-.54a1.87,1.87,0,0,1,1.49-.59,18.25,18.25,0,0,1,2.24.46,2.09,2.09,0,0,0,1.19-.12,8.83,8.83,0,0,0,1.1-.86,2.06,2.06,0,0,1,.75-.35,2.34,2.34,0,0,1,.79,0c.49.08.91.22,1.31.25a4.46,4.46,0,0,0,2.07-.58,4,4,0,0,1,1.51-.43C171.15,246.58,171.35,246.67,171.34,246.7Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,249.57a2.71,2.71,0,0,1-1.54,1,4.39,4.39,0,0,1-2,.21,4.78,4.78,0,0,0-1.11-.1,1.2,1.2,0,0,0-.83.62,2,2,0,0,1-1.09.84,3,3,0,0,1-1.26,0,9.43,9.43,0,0,0-1.92-.29,1.72,1.72,0,0,0-1.12.47c-.2.21-.25.39-.28.38s0-.21.14-.5a1.78,1.78,0,0,1,1.23-.68,8,8,0,0,1,2,.19,1.76,1.76,0,0,0,1.91-.74,2.47,2.47,0,0,1,.47-.51,1.39,1.39,0,0,1,.69-.28,4.52,4.52,0,0,1,1.22.13,4.42,4.42,0,0,0,1.88-.1A10,10,0,0,0,171.48,249.57Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,255.61a3.89,3.89,0,0,1-1,0,8.35,8.35,0,0,1-1.17-.05c-.46,0-1-.07-1.55-.17a30.1,30.1,0,0,1-4-.88,38.69,38.69,0,0,1-4.64-1.76,55,55,0,0,1-7.84-4.42c-1-.65-1.72-1.19-2.23-1.58a4.18,4.18,0,0,1-.77-.64,4,4,0,0,1,.88.49l2.3,1.45a70,70,0,0,0,7.85,4.27,43.45,43.45,0,0,0,4.58,1.77,34.33,34.33,0,0,0,3.89,1C129.46,255.5,130.89,255.52,130.88,255.61Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23,267.64a9.83,9.83,0,0,1-1.52-.31,16.65,16.65,0,0,1-1.75-.48c-.67-.2-1.45-.43-2.28-.75a52.22,52.22,0,0,1-5.73-2.51,70.27,70.27,0,0,1-6.58-3.93,84,84,0,0,1-10.74-8.82c-1.28-1.24-2.29-2.27-3-3a11.19,11.19,0,0,1-1-1.16,8.32,8.32,0,0,1,1.14,1c.71.69,1.75,1.68,3.06,2.88a95,95,0,0,0,10.78,8.68,73.21,73.21,0,0,0,6.51,3.93,52.5,52.5,0,0,0,5.65,2.58c.81.35,1.58.59,2.24.82s1.24.42,1.72.56A10.18,10.18,0,0,1,140.23,267.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.78,231.13a19.12,19.12,0,0,1-2.83,1.43c-1.77.82-4.24,1.92-7,3.09s-5.25,2.19-7.08,2.89c-.91.34-1.66.61-2.18.78a3,3,0,0,1-.82.22,23.52,23.52,0,0,1,2.88-1.31l7-3,7-3A22.87,22.87,0,0,1,190.78,231.13Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.6,193.13a1.84,1.84,0,0,1,.32.32l.85,1c.74.83,1.84,2,3.25,3.41s3.14,3,5,5a37.45,37.45,0,0,1,5.33,6.77,22.1,22.1,0,0,1,2.85,8.13c.35,2.63.45,5,.54,7s.11,3.61.12,4.73v1.28a1.42,1.42,0,0,1,0,.45,2.19,2.19,0,0,1-.05-.44c0-.35,0-.77-.08-1.29-.07-1.18-.16-2.78-.27-4.71s-.27-4.36-.64-7a22.13,22.13,0,0,0-2.82-7.95,38.93,38.93,0,0,0-5.24-6.71c-1.81-1.91-3.52-3.57-4.89-5s-2.46-2.65-3.16-3.52l-.79-1C172.67,193.27,172.58,193.14,172.6,193.13Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.91,244.68a10.09,10.09,0,0,1-1.35.81l-3.77,2c-3.19,1.7-7.61,4-12.5,6.57s-9.57,4.94-12.79,6.57l-.19.09-.05-.19c-.41-1.63-.76-3-1-4a9.58,9.58,0,0,1-.31-1.46,9,9,0,0,1,.48,1.41c.3,1,.69,2.33,1.17,3.94l-.23-.1c3.18-1.71,7.7-4.09,12.72-6.7s9.34-4.82,12.57-6.45l3.83-1.91A9.41,9.41,0,0,1,206.91,244.68Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.18,262.11a5,5,0,0,1,0,.73c0,.52-.1,1.21-.16,2.08-.18,1.81-.3,4.43-.47,7.67-.28,6.48-.37,15.45-.21,25.35s.46,18.87.72,25.35c.13,3.21.23,5.82.31,7.68,0,.88.06,1.57.07,2.09a3.37,3.37,0,0,1,0,.73,3.21,3.21,0,0,1-.09-.72c0-.52-.1-1.21-.16-2.09-.13-1.81-.3-4.43-.46-7.67-.35-6.49-.72-15.45-.87-25.36s0-18.89.36-25.38c.21-3.24.38-5.86.61-7.67.11-.86.19-1.56.25-2.07A3.24,3.24,0,0,1,159.18,262.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.58,177s-16,6.83-21,17.66-15.06,45.18-15.29,51.54,11.53,26.12,11.53,26.12l18.59-11.77-3.53-8.7,5.65-37.42Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.94,467.54h0a2.26,2.26,0,0,1-2.26-2.26c0-1.83.29-182.69.21-185.61-.18-6.24-4-9.09-4.14-9.21a2.28,2.28,0,0,1-.5-3.16,2.24,2.24,0,0,1,3.13-.53c.24.17,5.8,4.19,6,12.77.09,3-.19,178.28-.2,185.74A2.26,2.26,0,0,1,113.94,467.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09,293.11h0a2.26,2.26,0,0,1-2.26-2.26c0-6.72,0-16.94,0-17.54a2.23,2.23,0,0,1,2.1-2.38,2.31,2.31,0,0,1,2.43,2.13c0,.11,0,.43,0,17.79A2.26,2.26,0,0,1,101.09,293.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.58,261l-4.38,3.83c-1.1,1-2.47,9.46-2.47,9.46s4.8,5.14,6.85,5.35a5.54,5.54,0,0,0,3.7-1.17s2.06,1.17,3.29.14-1.71-7.68-1.71-7.68-1.11-3.22,2-3l1.34,2.41,3.36,5.74s2-.27,2.39-1.3-.89-4.44-.89-4.44a5,5,0,0,0,.62-4.06c-.75-2-2-5.62-5.62-6.44S104.58,261,104.58,261Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,277.59a22.83,22.83,0,0,1-1.63-1.74,27.2,27.2,0,0,0-4.39-3.66,4.17,4.17,0,0,1-1.2-1.24,2.54,2.54,0,0,1-.28-1.62,5,5,0,0,1,1.18-2.39c.48-.57.87-1,1.12-1.34s.38-.51.41-.49a6.26,6.26,0,0,1-1.26,2,5,5,0,0,0-1,2.24,2.17,2.17,0,0,0,.25,1.34,3.73,3.73,0,0,0,1.08,1.09,21.5,21.5,0,0,1,4.35,3.82A8.12,8.12,0,0,1,108.08,277.59Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.15,266.8c.11.1-.43.77-.66,1.77s-.09,1.83-.22,1.87a2.2,2.2,0,0,1-.24-2C113.3,267.32,114.08,266.7,114.15,266.8Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.67,243a7.21,7.21,0,0,1,1.29,0c.41,0,.92,0,1.51,0l2,.25c.74.1,1.52.34,2.38.52.43.11.85.29,1.29.44a8.82,8.82,0,0,1,1.34.52,22.2,22.2,0,0,1,5.42,3.41,34.62,34.62,0,0,1,4.45,4.59c1.25,1.51,2.3,2.93,3.2,4.1s1.63,2.12,2.15,2.76a7,7,0,0,1,.77,1,6.68,6.68,0,0,1-.91-.91c-.57-.6-1.34-1.52-2.27-2.67s-2-2.54-3.28-4a35.89,35.89,0,0,0-4.42-4.51,23,23,0,0,0-5.28-3.38,12.72,12.72,0,0,0-1.31-.52c-.44-.15-.84-.34-1.26-.45-.84-.2-1.61-.45-2.33-.57l-2-.32c-.58-.07-1.08-.08-1.49-.12A7.49,7.49,0,0,1,89.67,243Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.15,210.87a9,9,0,0,1-.2,1.59c-.16,1-.42,2.49-.74,4.3-.71,3.69-1.65,8.66-2.7,14.14s-1.88,10.54-2.4,14.18c-.25,1.76-.46,3.22-.61,4.32a12.33,12.33,0,0,1-.27,1.58,11.17,11.17,0,0,1,.08-1.6c.08-1,.24-2.51.47-4.34.44-3.66,1.22-8.7,2.27-14.23s2.09-10.5,2.83-14.11c.36-1.75.66-3.19.89-4.27A12.18,12.18,0,0,1,114.15,210.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.57 469.19 110.07 469.19 111.65 462.43 116.68 462.43 118.57 469.19",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,185s.26.14.68.48a13.8,13.8,0,0,1,1.62,1.6,17.2,17.2,0,0,1,2,2.75,20.62,20.62,0,0,1,1.71,3.78,20.94,20.94,0,0,1,.84,4.07,18.17,18.17,0,0,1,0,3.38,14.1,14.1,0,0,1-.37,2.25c-.14.52-.23.8-.27.79s.19-1.17.28-3.06a20.33,20.33,0,0,0-.12-3.31,23.19,23.19,0,0,0-.86-4,23.53,23.53,0,0,0-1.63-3.71,21.08,21.08,0,0,0-1.85-2.75C110.46,185.8,109.55,185,109.62,185Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,121.76c1.32-2.36,4-4.15,6.64-3.73a9.17,9.17,0,0,1,7.87-10.26c2.58-.23,5.35.65,7.69-.46,1.46-.69,2.48-2,3.67-3.13,5-4.6,13.49-4.15,18.62.31s6.9,12.06,5.22,18.64c-.78,3.06-2.23,6-2.23,9.18,0,3,1.29,5.78,1.57,8.73s-1,6.51-3.95,7.06l-29.2,8a11.55,11.55,0,0,1-12.74-4.21c-1.91-2.71-2.52-6.1-3.08-9.36a87.57,87.57,0,0,1-1.56-12.89A15.43,15.43,0,0,1,121,121.76Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,133.14a4.49,4.49,0,0,1,5.76-1c5.1.07,9.71-.19,13.48,3.26A17.43,17.43,0,0,1,139.52,149a14.78,14.78,0,0,1-8,12.26,12.84,12.84,0,0,1-14.23-2.1,11.39,11.39,0,0,1-1.66-14,21.53,21.53,0,0,1-2.42-5.93A7.32,7.32,0,0,1,114.52,133.14Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,188a12.88,12.88,0,0,1-13-12.5L128,133.34c-.7-11.31,5.29-21.15,16.62-21.54l1,0a20.26,20.26,0,0,1,19.74,19.11c.55,9.8,1,20.65.85,25.9-.4,10.86-11.31,12.29-11.31,12.29s0,2.52.07,5.71A12.89,12.89,0,0,1,142.25,188Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,169.26a26.25,26.25,0,0,1-14-4.52s3.26,8,14.13,7.27Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,151.69a2.41,2.41,0,0,1,2.56-.57,2.38,2.38,0,0,1,1.49,2.16,2.4,2.4,0,0,1-1.46,2.19,3,3,0,0,1-1.89.05,2.36,2.36,0,0,1-1.22-.75,2.09,2.09,0,0,1-.17-2,3,3,0,0,1,1-1.36",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,139.07a1.54,1.54,0,0,1-1.53,1.53,1.48,1.48,0,0,1-1.57-1.43,1.55,1.55,0,0,1,1.53-1.53A1.48,1.48,0,0,1,162.66,139.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,136.23c-.19.2-1.35-.7-3-.74s-2.92.77-3.09.57.12-.46.66-.83a4.2,4.2,0,0,1,2.48-.7,4,4,0,0,1,2.4.84C162.92,135.77,163.09,136.14,163,136.23Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,139.07a1.54,1.54,0,0,1-1.53,1.53,1.48,1.48,0,0,1-1.57-1.43,1.55,1.55,0,0,1,1.54-1.53A1.47,1.47,0,0,1,146.69,139.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.91,136.24c-.19.2-1.35-.7-3-.73s-2.92.77-3.09.56.11-.45.66-.83a4.28,4.28,0,0,1,2.48-.7,4.11,4.11,0,0,1,2.4.84C146.84,135.79,147,136.16,146.91,136.24Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28,148.79a11,11,0,0,1,2.73-.43c.43,0,.83-.11.91-.4a2.19,2.19,0,0,0-.25-1.27l-1.19-3.28c-1.64-4.66-2.81-8.5-2.62-8.56s1.67,3.67,3.31,8.33c.39,1.15.77,2.25,1.13,3.3a2.48,2.48,0,0,1,.18,1.68,1.09,1.09,0,0,1-.72.61,3.32,3.32,0,0,1-.73.08A11.35,11.35,0,0,1,152.28,148.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,149.82c.27,0,.23,1.81,1.75,3.13s3.46,1.17,3.47,1.43-.44.34-1.26.34a4.5,4.5,0,0,1-2.89-1.09,4,4,0,0,1-1.36-2.62C147,150.25,147.22,149.81,147.34,149.82Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,129.71c-.18.46-1.84.2-3.81.39s-3.56.68-3.81.27c-.11-.2.18-.62.82-1a6.66,6.66,0,0,1,5.81-.5C146.83,129.14,147.18,129.5,147.11,129.71Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45,131.49c-.3.37-1.44-.05-2.83-.11s-2.56.2-2.82-.21c-.11-.19.08-.57.6-.91a3.91,3.91,0,0,1,2.32-.57,3.86,3.86,0,0,1,2.23.82C162.43,130.91,162.58,131.3,162.45,131.49Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.69,141.54c-.18-.08-7.41-2.39-7.35,5.05s7.51,5.84,7.52,5.63S128.69,141.54,128.69,141.54Z",
    style: {
      fill: "#ffc5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.57,149.42s-.13.09-.35.19a1.3,1.3,0,0,1-1,0,3.2,3.2,0,0,1-1.51-2.86,4.41,4.41,0,0,1,.35-1.86,1.49,1.49,0,0,1,1-1,.66.66,0,0,1,.77.35c.1.2,0,.35.09.36s.16-.12.1-.43a.78.78,0,0,0-.3-.46,1,1,0,0,0-.72-.19,1.84,1.84,0,0,0-1.34,1.17,4.37,4.37,0,0,0-.43,2.07c.06,1.5.83,2.9,1.91,3.2a1.41,1.41,0,0,0,1.18-.2C126.55,149.6,126.59,149.43,126.57,149.42Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,137.78c0,.13-.41.28-.91.46s-.93.3-1,.18.28-.45.84-.63S165,137.65,165,137.78Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.61,139c0,.13-.55.16-1.19.16s-1.18,0-1.2-.16.51-.32,1.2-.31S165.63,138.83,165.61,139Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,138.28c0,.13-.75.16-1.64.16s-1.62,0-1.63-.17.72-.31,1.63-.31S139.72,138.15,139.71,138.28Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61,139.78c0,.14-.65.12-1.41.12s-1.39,0-1.42-.11.6-.36,1.42-.36S139.64,139.66,139.61,139.78Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48,142.21s-.21.35-.74.64a4.07,4.07,0,0,1-2.32.47,4.14,4.14,0,0,1-2.2-.9c-.47-.39-.65-.73-.6-.77a6.89,6.89,0,0,0,2.84,1.2A7.06,7.06,0,0,0,146.48,142.21Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24,141.85c0,.12-.74.53-1.81.53s-1.86-.41-1.81-.52.84,0,1.81,0S147.2,141.72,147.24,141.85Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39,140.82a4.66,4.66,0,0,1-2.66.9,4.6,4.6,0,0,1-2.77-.39c0-.14,1.24.06,2.73-.09S163.34,140.69,163.39,140.82Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.58,141.39a3.34,3.34,0,0,1-2.35,1.29,3.28,3.28,0,0,1-2.65-.41,18.91,18.91,0,0,0,2.57-.06A22.08,22.08,0,0,0,162.58,141.39Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.11,128.14a6.56,6.56,0,0,1-1.88.45,24.51,24.51,0,0,1-4.66.25,23.42,23.42,0,0,1-4.63-.63,6.17,6.17,0,0,1-1.83-.6c0-.14,2.88.62,6.48.76S159.08,128,159.11,128.14Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.24,126.83a22,22,0,0,1-6,.56,22.4,22.4,0,0,1-6-.6c0-.13,2.7.12,6,.13S160.22,126.7,160.24,126.83Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76,132.23c-.13,0-.17-.35-.19-.73s0-.7.14-.74.32.28.34.72S151.88,132.25,151.76,132.23Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,132.52c0,.12-.57,0-.8-.62s.05-1.05.17-1,.11.42.28.82S154.11,132.4,154.05,132.52Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.09,149.34c0,.14-.52.22-1,.62s-.67.86-.81.84-.12-.71.51-1.21S147.12,149.22,147.09,149.34Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.14,149.21c0,.13-.31.2-.52.45s-.26.53-.39.58-.15-.07-.18-.25a.85.85,0,0,1,.22-.64.83.83,0,0,1,.61-.29C145.06,149.07,145.15,149.15,145.14,149.21Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.08,178.31s-.21,0-.5-.25a2.28,2.28,0,0,1-.72-1.36,6.06,6.06,0,0,1,.09-2.26,4.73,4.73,0,0,0,0-2.53c-.15-.41-.45-.78-.63-1.26a2.22,2.22,0,0,1,0-1.4,1.89,1.89,0,0,0,0-1.05,4.83,4.83,0,0,0-.46-.87,1.76,1.76,0,0,1-.3-1.51c.16-.38.42-.42.41-.4s-.16.14-.23.45a1.64,1.64,0,0,0,.4,1.28,4.46,4.46,0,0,1,.55.91,2.15,2.15,0,0,1,0,1.28,1.88,1.88,0,0,0,0,1.15c.14.38.44.75.63,1.24a4.89,4.89,0,0,1,0,2.79,6.31,6.31,0,0,0-.19,2.12,2.28,2.28,0,0,0,.52,1.29C137.93,178.18,138.1,178.28,138.08,178.31Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.81,179.22s-.24,0-.56-.19a2.79,2.79,0,0,1-.89-1.34,23.93,23.93,0,0,1-1.22-5,10.75,10.75,0,0,1,0-1.49,8.8,8.8,0,0,0,0-1.33c0-.82-.83-1.1-1.34-1.58a1.37,1.37,0,0,1-.49-.83.84.84,0,0,1,.26-.7c.33-.3.62-.12.58-.11s-.24,0-.44.23a.68.68,0,0,0-.14.53,1.19,1.19,0,0,0,.45.63c.23.2.55.35.88.61a1.65,1.65,0,0,1,.67,1.17,9.21,9.21,0,0,1,0,1.39,9.91,9.91,0,0,0,.05,1.43,34.53,34.53,0,0,0,1.06,5,2.92,2.92,0,0,0,.69,1.3C142.61,179.12,142.82,179.18,142.81,179.22Z",
    style: {
      fill: "#f6957f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11,122.39a13,13,0,0,1-19.81-.86,8.47,8.47,0,0,1-14.18.76,23,23,0,0,1-1.22,15.64,7.24,7.24,0,0,1-1.9,2.71c-.88.69-3.06,1.24-4.06.74s-.48-1.73-.84-2.7a21.87,21.87,0,0,1,40.53-16.4",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,126.69c0-.07.89.48,2.39,1a15,15,0,0,0,6.11.92,13.24,13.24,0,0,0,5.89-1.76,5.91,5.91,0,0,0,1.75-1.84,3.32,3.32,0,0,1-1.54,2.14,12.19,12.19,0,0,1-6.07,2,13.54,13.54,0,0,1-6.28-1.09,11.45,11.45,0,0,1-1.7-.93C119.63,126.88,119.43,126.72,119.45,126.69Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,130.36a24.81,24.81,0,0,0,7.94,1.13,24.74,24.74,0,0,0,7.76-2,7.21,7.21,0,0,1-2.08,1.19,16.8,16.8,0,0,1-11.41.62A7.27,7.27,0,0,1,120.3,130.36Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,117.83c-.06,0,.05-.74-.12-2a10.38,10.38,0,0,0-2.12-5,9.69,9.69,0,0,0-6.93-3.76,15.64,15.64,0,0,0-9.52,2.46,16.52,16.52,0,0,0-2.13,1.54c-.67.54-1.23,1.19-1.93,1.75a3.24,3.24,0,0,1-1.21.62,2.21,2.21,0,0,1-1.37-.09,7,7,0,0,1-1.93-1.54,6.55,6.55,0,0,0-3.85-1.7,6.32,6.32,0,0,0-3.62.71A6.76,6.76,0,0,0,132,115a9.51,9.51,0,0,0-.25,2,1.74,1.74,0,0,1-.08-.53,6.25,6.25,0,0,1,.13-1.53,6.88,6.88,0,0,1,3.27-4.49,6.62,6.62,0,0,1,3.84-.82A6.89,6.89,0,0,1,143,111.4a7,7,0,0,0,1.8,1.43,2,2,0,0,0,2.08-.48c.63-.49,1.21-1.17,1.91-1.73A16.45,16.45,0,0,1,151,109a16,16,0,0,1,9.84-2.5,10.34,10.34,0,0,1,4.28,1.38,9.91,9.91,0,0,1,2.9,2.63,10.17,10.17,0,0,1,2,5.23,7,7,0,0,1,0,1.53A3.23,3.23,0,0,1,170,117.83Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,126.69a14.21,14.21,0,0,1,.27,2.37c.13,1.45.37,3.46.77,5.65a49.14,49.14,0,0,0,1.34,5.53,20.5,20.5,0,0,1,.74,2.25,7,7,0,0,1-1.08-2.13A32.92,32.92,0,0,1,120,134.8a41,41,0,0,1-.63-5.72A9.32,9.32,0,0,1,119.45,126.69Z",
    style: {
      fill: "#F6F9FC"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3107c4c3bd11cdcd66cd41a0227971bc.svg";
export { ForwardRef as ReactComponent };